import React, { useState, useEffect, useContext, useRef } from "react";
import AdminContext from "../../../StateContext/Application";
// import { apiurl } from '../../../../path';
import { Link } from "react-router-dom";
// import "./rejectpanel.css";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../../path";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import GooglePagination from "../../../styles/GooglePagination";

const ViewDemandGeneration = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetBudgetHeadInfo, TechnicalOutwards, Usermenu, Getyears } = context;

  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [proposallist, setProposalList] = useState([]);

  const [UserRole, setUserRole] = useState("");
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [SelectedDistrict, setSelectedDistrict] = useState([]);
  // const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] = useState("");
  const [statusofData, setstatusofData] = useState("Sent to Bank");
  const [statusofData1, setstatusofData1] = useState("");
  const [RoleID, setroleID] = useState(null);
  const [typeofData, settypeofData] = useState("District");
  const [openDistrict, setOpenDistrict] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAll, setShowAll] = useState(false);
  const [selectedDemandID, setSelectedDemandID] = useState();
  const billsPerPage = showAll ? filteredBills.length : 10;
  const [searchTerm, setSearchTerm] = useState("");
  const budgetEstimation = proposallist;

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  const [selectedImage, setSelectedImage] = useState("");
  const [progressData, setProgressData] = useState([]);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const [exportingPDF, setExportingPDF] = useState(false);
  const [loading, setloading] = useState(false);
  const displayedGRS = exportingPDF ? filteredBills : currentBills;

  const [
    fetchSpecificDemandDeductionDetail,
    setfetchSpecficDemandDeductionDetail,
  ] = useState([]);
  const [selectedBillData, setselectedBillData] = useState({});
  const [showspecific, setShowSpecific] = useState(0);

  const billSlipRef = useRef(null);
  const [userDistrict, setuserDistrict] = useState({});

  const [exportingBillSlipPDF, setExportingBillSlipPDF] = useState(false);

  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };
  const commonWidth = `${100 / 7}%`; // whatever the current width of Department Auditor looks like

  const headerStyle1 = {
    width: commonWidth,
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const cellStyle = {
    width: commonWidth, // 100% / 7 columns
    padding: "8px",
    textAlign: "center",
    //   whiteSpace: 'nowrap'
  };

  const getTechnicalInwardsList = async () => {
    let data = await GetBudgetHeadInfo("All", "GetDemandGenerationList");
    let data1 = await TechnicalOutwards("FundBDS");
    const { status, message, Tabletype } = data1;

    if (status) {
      setTechnicalInwards(message);
      setProposalList(message);
      // setFilteredBills(message);
      setUserRole(Tabletype);
    } else {
      alert(message);
    }
  };
  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setroleID(roleID);
      console.log("sffdsf", data?.Data);
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };
  useEffect(() => {
    getTechnicalInwardsList();
    getmenu();
  }, []);

  const allDistricts = [
    ...new Set(AllDistrict?.map((d) => d.District_Marathi)),
  ];
  const isAllSelected = SelectedDistrict.length === allDistricts.length;

  const toggleAllDistricts = () => {
    setSelectedDistrict(isAllSelected ? [] : allDistricts);
  };
  const handleDistrictToggle = (district) => {
    setSelectedDistrict((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };

  useEffect(() => {
    let filtered = [...technicalInwards];
    console.log("All data ---> ", technicalInwards);
    if (typeofData === "District" && RoleID === 29) {
      filtered = filtered.filter(
        (item) =>
          item.BudgetID ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );
      console.log("filtered Date 3054", filtered);
    } else if (typeofData === "State" && RoleID === 29) {
      filtered = filtered.filter(
        (item) => item.BudgetID === "2515-1238(MLA Representative)",
      );
    }
    // 🔹 Filter by District (MULTI-SELECT)
    if (SelectedDistrict?.length > 0) {
      filtered = filtered.filter((item) =>
        SelectedDistrict.includes(item.District),
      );
    }

    // 🔹 Filter by Approval / Status
    if (statusofData1) {
      if (statusofData1 === "false") {
        filtered = filtered.filter(
          (item) =>
            item.Approvance1 === "false" ||
            item.Approvance2 === "false" ||
            item.Approvance3 === "false" ||
            item.Approvance4 === "false" ||
            item.Approvance5 === "false" ||
            item.Approvance6 === "false" ||
            item.Approvance9 === "false" ||
            item.Approvance8 === "false" ||
            item.Approvance9 === "false",
        );
      } else if (statusofData1 === "Approved") {
        // ✅ Added block
        filtered = filtered.filter(
          (item) =>
            item.Approvance1 === "true" &&
            item.Approvance2 === "true" &&
            item.Approvance3 === "true" &&
            item.Approvance4 === "true" &&
            item.Approvance5 === "true" &&
            item.Approvance6 === "true" &&
            item.Approvance9 === "true" &&
            item.Approvance8 === "true" &&
            item.Approvance9 === "true",
        );
      } else if (statusofData1 === "Rejected") {
        filtered = filtered.filter((item) => item.Status === "Rejected");
      }
    }

    console.log("Filter data ---> ", filtered);

    // 🔹 Search Filter
    if (searchTerm.trim()) {
  const lower = searchTerm.toLowerCase();
  filtered = filtered.filter((bill) => {
    const matchesValues = Object.values(bill).some((val) =>
      String(val ?? "").toLowerCase().includes(lower),
    );
    const matchesReceived =
      bill.Status === "Completed" && "received".includes(lower);
    return matchesValues || matchesReceived;
  });
}

    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [
    statusofData1,
    searchTerm,
    technicalInwards,
    SelectedDistrict,
    typeofData,
  ]);

  const selectedBillDetails = (BillID) => {
    const result = budgetEstimation
      .filter((item) => item.DemandGenerationID == BillID)
      .map((item) => ({
        "Bill ID": item.DemandGenerationID,
        "Bill Number": item.RABillNumber,
        "Proposal ID": item.ProjectID,
        "Head ID": item.BudgetID,
        District: item.District,
        "Contractor Name": item.ContractorName,
        "Work Order UID": item.WorkOrderUID,
        "Upload Bill Copy": item.UploadBillCopy,
        Remark: item.Remark,
        "Bill Amount": item.BillAmount,
        "Net Payable Amount": item.NetPayableAmount,
        "Deduction Amount": item.DeductionAmount,
        Date: new Date(item.Date).toLocaleString(),
      }));

    console.log("------------------", result);
    setSelectedProposal(result[0]);
  };

  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "AllDistrict");
      // console.log("Data i get:: ", res);
      setAllDistrict(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchGramPanachayatInfo();
  }, []);

  const totalBillamt = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.BillAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const totalpayableamt = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.NetPayableAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const totaldeductionamt = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.DeductionAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  const exportTableByClassToExcel = async (
    bills,
    filename = "Bills_Outward.xlsx",
  ) => {
    if (!bills || bills.length === 0) {
      alert("No data available");
      return;
    }

    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      const getStatus = (val) =>
        val === "true" ? "✓" : val === "false" ? "✕" : "-";

      const excelData = bills.map((proposal, index) => ({
        "Sr.No.": index + 1,
        "Bill ID": proposal.DemandGenerationID,
        "Bill Number": proposal.RABillNumber,
        "Head ID": proposal.BudgetID,
        "Work Name": proposal.ProjectID,
        "Technical Sanction Number": proposal.BillNumber,
        "Physical Progress(in %)": proposal.physicalValueOfProgress,
        District: proposal.District,
        "Vendor Name": proposal.ContractorName,
        "Upload Bill Copy": proposal.UploadBillCopy || "No File",
        "Bill Copy": proposal.BillCopy || "No File",
        Remark: proposal.Remark || "",
        "Bill Amount": proposal.BillAmount || 0,
        "Net Payable Amount": proposal.NetPayableAmount || 0,
        "Deduction Amount": proposal.DeductionAmount || 0,
        Date: proposal.Date ? new Date(proposal.Date).toLocaleString() : "",
        Status: proposal.Status === "Completed" ? "Received" : proposal.Status || "-",
        "Department Auditor": getStatus(proposal.Approvance1),
        "Department HOD(EE)": getStatus(proposal.Approvance2),
        "FD Auditor": getStatus(proposal.Approvance3),
        "FD AAO": getStatus(proposal.Approvance4),
        "FD AO": getStatus(proposal.Approvance5),
        "Deputy CAFO": getStatus(proposal.Approvance6),
        CAFO: getStatus(proposal.Approvance9),
      }));

      /* 🔢 TOTAL ROW */
      const totalRow = {
        "Sr.No.": "Total",
        "Bill ID": "",
        "Bill Number": "",
        "Head ID": "",
        "Work Name": "",
        "Technical Sanction Number": "",
        "Physical Progress(in %)": "",
        District: "",
        "Vendor Name": "",
        "Upload Bill Copy": "",
        "Bill Copy": "",
        Remark: "",
        "Bill Amount": bills.reduce(
          (sum, b) => sum + Number(b.BillAmount || 0),
          0,
        ),
        "Net Payable Amount": bills.reduce(
          (sum, b) => sum + Number(b.NetPayableAmount || 0),
          0,
        ),
        "Deduction Amount": bills.reduce(
          (sum, b) => sum + Number(b.DeductionAmount || 0),
          0,
        ),
        Date: "",
        "Department Auditor": "",
        "Department HOD(EE)": "",
        "FD Auditor": "",
        "FD AAO": "",
        "FD AO": "",
        "Deputy CAFO": "",
        CAFO: "",
      };

      excelData.push(totalRow);

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      /* Column width */
      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({
        wch: 22,
      }));

      /* Freeze header */
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      /* Filter */
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: {
            r: excelData.length,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Bills");
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };

  const downloadTableOnlyAsPDF = async (
    tableClass,
    filename,
    title,
    chunkSize = 500, // 🔥 300–500 recommended
  ) => {
    const originalTable = document.querySelector(`.${tableClass}`);
    if (!originalTable) {
      setExportingPDF(false);
      return;
    }

    setloading(true);
    setExportingPDF(true);

    // Allow loader to render first
    await new Promise((resolve) => setTimeout(resolve, 600));

    try {
      const originalRows = originalTable.querySelectorAll("tbody tr");
      const totalRows = originalRows.length;

      if (!totalRows) {
        setloading(false);
        setExportingPDF(false);
        return;
      }

      for (let start = 0; start < totalRows; start += chunkSize) {
        const end = Math.min(start + chunkSize, totalRows);

        // 🔥 Clone table cleanly
        const tableClone = originalTable.cloneNode(true);
        const rows = tableClone.querySelectorAll("tbody tr");

        // Remove rows outside current chunk
        rows.forEach((row, index) => {
          if (index < start || index >= end) {
            row.remove();
          }
        });

        // Hide cloned table from view
        tableClone.style.position = "absolute";
        tableClone.style.left = "-9999px";
        tableClone.style.top = "0";
        document.body.appendChild(tableClone);

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const topMargin = 25;
        const sideMargin = 10;
        const bottomMargin = 15;

        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
          align: "center",
        });

        const canvas = await html2canvas(tableClone, {
          scale: 1,
          useCORS: true,
          backgroundColor: "#2C78DB",
        });

        const imgWidth = pageWidth - sideMargin * 2;
        const pxToMm = imgWidth / canvas.width;

        const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
        const usablePageHeightPx = usablePageHeightMm / pxToMm;

        let renderedHeight = 0;
        let pageNumber = 0;

        while (renderedHeight < canvas.height) {
          const sliceHeight = Math.min(
            usablePageHeightPx,
            canvas.height - renderedHeight,
          );

          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");

          pageCanvas.width = canvas.width;
          pageCanvas.height = sliceHeight;

          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight,
          );

          const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

          if (pageNumber > 0) pdf.addPage();

          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm,
          );

          renderedHeight += sliceHeight;
          pageNumber++;
        }

        pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

        document.body.removeChild(tableClone);

        // Small delay prevents UI freezing
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      setExportingPDF(false);
      setloading(false);
    }
  };

  const settingshowspecific3 = async (ID) => {
    try {
      let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(ID);
      setShowSpecific(4);
      let filtered = res;
      console.log("filtered............", filtered);
      filtered = filtered.filter((val) => val.DemandGenerationID == ID);
      setselectedBillData(filtered[0]);
      console.log("selected Bill ---> ", filtered[0]);
    } catch (err) {
      console.log(err);
    }
  };
  const exportBillSlipPDF = async () => {
    if (!billSlipRef.current) {
      alert("Bill slip not found");
      return;
    }

    setExportingBillSlipPDF(true);

    try {
      const canvas = await html2canvas(billSlipRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 5;
      const maxImgWidth = pageWidth - margin * 2;
      const maxImgHeight = pageHeight - margin * 2;
      const widthRatio = maxImgWidth / canvas.width;
      const heightRatio = maxImgHeight / canvas.height;
      const ratio = Math.min(widthRatio, heightRatio);
      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;

      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        (pageWidth - imgWidth) / 2,
        margin,
        imgWidth,
        imgHeight,
      );

      const transactionNo =
        selectedBillData?.DemandGenerationID || selectedDemandID;
      pdf.save(`Bill_Slip_${transactionNo || "RDD"}.pdf`);
    } catch (error) {
      console.error("Bill slip PDF export error:", error);
      alert("Failed to export bill slip PDF. Please try again.");
    } finally {
      setExportingBillSlipPDF(false);
    }
  };

  const BackFunction = () => {
    setfetchSpecficDemandDeductionDetail([]);
    setSelectedBills("");
    setselectedBillData([]);
    setShowSpecific(0);
  };

  const labelStyle = {
    border: "1px solid #000",
    padding: "6px",
    width: "18%",
    fontWeight: "bold",
    background: "#f5f5f5",
  };

  const valueStyle = {
    border: "1px solid #000",
    padding: "6px",
  };

  const tableHead = {
    border: "1px solid #000",
    background: "#d9d9d9",
    padding: "8px",
    textAlign: "center",
  };

  const tableCell = {
    border: "1px solid #000",
    padding: "8px",
    textAlign: "center",
  };
  const vendorData = fetchSpecificDemandDeductionDetail?.find(
    (item) => item.TypeOfAmount === "Total Amount Payable",
  );
  const officerStyle = {
    marginTop: "8px",
    fontSize: "12px",
    fontWeight: "bold",
    textAlign: "center",
  };

  const officerMarathiStyle = {
    fontSize: "11px",
    textAlign: "center",
    marginTop: "3px",
  };
  const footerTitleStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "8px",
  };

  const footerTitleTdStyle = {
    border: "1px solid #555",
    padding: "6px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "bold",
  };

  const remarksTableStyle = {
    width: "100%",
    borderCollapse: "collapse",
  };

  const remarksTableTdStyle = {
    border: "1px solid #555",
    padding: "8px",
    fontSize: "11px",
    lineHeight: "18px",
    textAlign: "right",
  };

  const instructionTableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "-1px",
  };

  const instructionTableTdStyle = {
    border: "1px solid #555",
    padding: "10px",
    fontSize: "11px",
    lineHeight: "18px",
    textAlign: "justify",
  };

  const signatureTableStyle = {
    width: "100%",
    tableLayout: "fixed",
    borderCollapse: "collapse",
    marginTop: "-1px",
  };

  const signatureTableTdStyle = {
    border: "1px solid #555",
    height: "80px",
    width: "50%",
    verticalAlign: "bottom",
    padding: "10px",
  };

  const signBoxStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  };

  const signSpaceStyle = {
    height: "25px",
  };

  const signTitleStyle = {
    fontSize: "12px",
    fontWeight: "bold",
    textAlign: "center",
  };

  const openProgressModal = (images, location) => {
    try {
      const parsedImages = JSON.parse(images || "[]");
      const parsedLocations = JSON.parse(location || "[]");

      let imageArray = [];
      parsedImages.forEach((img) => {
        try {
          const nested = JSON.parse(img);
          if (Array.isArray(nested)) imageArray.push(...nested);
          else imageArray.push(img);
        } catch {
          imageArray.push(img);
        }
      });

      const combinedData = imageArray.map((image, index) => {
        let locationObj = {};
        const loc = parsedLocations[index];
        if (loc && loc !== "na" && loc !== "null" && loc !== "") {
          try {
            locationObj = JSON.parse(loc);
          } catch (err) {
            console.error("Invalid location JSON:", loc, err);
          }
        }
        return { image, location: locationObj };
      });

      setProgressData(combinedData);
      setShowProgressModal(true);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {false && (
        <div>
          <div
            style={{
              overflowX: "hidden",
              display: "grid",
              justifyContent: "center",
              padding: "20px 0px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "80vw",
                maxWidth: "1200px",
                marginBottom: "15px",
              }}
            >
              <h4 style={{ margin: "10px" }}>{t("Bill List")}</h4>
              <input
                type="text"
                placeholder={t("Search")}
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
                style={{
                  width: "250px",
                  padding: "8px 12px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  backgroundColor: "aliceblue",
                  fontSize: "14px",
                  marginRight: "10px",
                }}
              />
            </div>

            <div
              style={{
                display: "grid",
                justifyContent: "center",
                boxShadow: "0px 0px 3px",
                borderRadius: "20px",
                width: "78vw",
              }}
            >
              <div
                style={{
                  overflowX: "auto",
                  width: "78vw",
                  borderRadius: "20px",
                }}
              >
                <table
                  style={{
                    backgroundColor: "white",
                    width: "130%",
                    borderRadius: "20px",
                    overflow: "hidden",
                    borderCollapse: "collapse",
                  }}
                >
                  <thead style={{ borderTop: "none" }}>
                    <tr
                      style={{
                        background:
                          "linear-gradient(to bottom, #CCEAF7, #CFE4F1, #CCE1EE, #D8D9EC)",
                        color: "black",
                        border: "none",
                        borderRadius: "10px",
                        overflow: "hidden",
                        height: "3rem",
                        fontSize: "12px",
                        textAlign: "center",
                      }}
                    >
                      <th style={{ width: "6%" }}>{t("Bill UID")}</th>
                      <th style={{ width: "7%" }}>{t("HeadCode Name")}</th>
                      <th style={{ width: "8%" }}>{t("Proposal UID")}</th>
                      <th style={{ width: "7%" }}>{t("RA Bill Number")}</th>
                      <th style={{ width: "6%" }}>{t("District")}</th>
                      <th style={{ width: "10%" }}>{t("Vendor Name")}</th>
                      <th style={{ width: "8%" }}>{t("Bill Amount")}</th>
                      <th style={{ width: "8%" }}>{t("Deduction Amount")}</th>
                      <th style={{ width: "8%" }}>{t("Payable Amount")}</th>
                      <th style={{ width: "8%" }}>{t("Remark")}</th>
                      <th style={{ width: "14%" }}>{t("Uploaded Files")}</th>
                      <th style={{ width: "10%" }}>{t("Date")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentBills?.map((technicalInwards, index) => {
                      const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                      return (
                        <tr
                          className="px-3"
                          key={index}
                          style={{
                            borderBottom: "1px solid #3b409e",
                            backgroundColor: bgColor,
                          }}
                        >
                          <td className="py-2">
                            {technicalInwards.DemandGenerationID}
                          </td>
                          <td className="py-2">{technicalInwards.BudgetID}</td>
                          <td className="py-2">{technicalInwards.ProjectID}</td>
                          <td className="py-2">
                            {technicalInwards.RABillNumber}
                          </td>
                          <td className="py-2">{technicalInwards.District}</td>
                          <td className="py-2">
                            {technicalInwards.ContractorName}
                          </td>
                          <td className="py-2">
                            {technicalInwards.BillAmount / 10000000} CR
                          </td>
                          <td className="py-2">
                            {technicalInwards.DeductionAmount / 10000000} CR
                          </td>
                          <td className="py-2">
                            {technicalInwards.NetPayableAmount / 10000000} CR
                          </td>
                          <td className="py-2">
                            {technicalInwards.Remark ? (
                              technicalInwards.Remark
                            ) : (
                              <p className="text-danger fw-bold my-auto">
                                {t("No Remark")}
                              </p>
                            )}
                          </td>
                          <td style={{ padding: "8px" }}>
                            {technicalInwards.UploadBillCopy ? (
                              <a
                                href={`${apiurl}/BillCopyDocsImages/${technicalInwards.UploadBillCopy}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {technicalInwards.UploadBillCopy}
                              </a>
                            ) : (
                              <p className="text-danger my-auto fw-bold">
                                {t("No File")}
                              </p>
                            )}
                          </td>
                          <td className="py-2">
                            {new Date(technicalInwards.Date).toLocaleString()}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                className="ms-auto"
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  margin: "10px 0",
                }}
              >
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 15px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    backgroundColor: currentPage === 1 ? "#ccc" : "blue",
                    color: "white",
                  }}
                >
                  {t("Previous")}
                </button>
                <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                  {t("Page")} {currentPage} {t("of")} {totalPages}
                </span>
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "6px 15px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    backgroundColor:
                      currentPage === totalPages ? "#ccc" : "blue",
                    color: "white",
                  }}
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {false && (
        <div
          className="col-12"
          style={{
            display: "grid",
            justifyContent: "center",
            maxWidth: "100%",
          }}
        >
          <div
            className="col-12 mb-3"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4 className="my-auto">{t("Bill Outwards")}</h4>
            <input
              type="text"
              placeholder={t("Search Here")}
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
              style={{
                width: "250px",
                padding: "8px 12px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                backgroundColor: "aliceblue",
                fontSize: "14px",
                marginRight: "10px",
              }}
            />
          </div>
          <div
            className="col-12"
            style={{
              background:
                "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
              display: "flex",
              overflowX: "auto",
              border: "1px solid #3b409e",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: "1200px",
              }}
            >
              <thead>
                <tr
                  style={{ color: "white", border: "none", height: "3.5rem" }}
                >
                  <th
                    style={{ minWidth: "150px", padding: "8px" }}
                    rowSpan={2}
                    colSpan={1}
                  >
                    {t("Bill Number")}
                  </th>
                  <th
                    style={{ width: "80%", border: "1px solid white" }}
                    colSpan={9}
                  >
                    {t("Approved by")}
                  </th>{" "}
                  {/* changed from 9 to 8 */}
                  <th
                    style={{
                      width: "10%",
                      textAlign: "center",
                      border: "1px solid white",
                    }}
                    colSpan={1}
                    rowSpan={2}
                  >
                    {t("Details")}
                  </th>
                </tr>
              </thead>

              <tbody>
                {currentBills?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="10"
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        backgroundColor: "#f9f9f9",
                      }}
                    >
                      {t("No data available")}
                    </td>
                  </tr>
                ) : (
                  currentBills?.map((proposal, index) => {
                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                    return (
                      <tr
                        style={{
                          borderBottom: "1px solid #3b409e",
                          backgroundColor: bgColor,
                        }}
                        key={proposal.DemandGenerationID || index}
                      >
                        <td style={{ padding: "8px" }}>
                          {proposal.RABillNumber}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            textAlign: "center",
                            borderRight: "1px solid #3b409e",
                          }}
                        >
                          {proposal.Approvance1 === "true"
                            ? "✅"
                            : proposal.Approvance1 === "false"
                              ? "❌"
                              : "-"}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            textAlign: "center",
                            borderRight: "1px solid #3b409e",
                          }}
                        >
                          {proposal.Approvance2 === "true"
                            ? "✅"
                            : proposal.Approvance2 === "false"
                              ? "❌"
                              : "-"}
                        </td>
                        <td style={cellStyle}>
                          {proposal.Approvance3 === "true"
                            ? "✅"
                            : proposal.Approvance3 === "false"
                              ? "❌"
                              : "-"}
                        </td>
                        <td style={cellStyle}>
                          {proposal.Approvance4 === "true"
                            ? "✅"
                            : proposal.Approvance4 === "false"
                              ? "❌"
                              : "-"}
                        </td>
                        <td style={cellStyle}>
                          {proposal.Approvance5 === "true"
                            ? "✅"
                            : proposal.Approvance5 === "false"
                              ? "❌"
                              : "-"}
                        </td>
                        <td style={cellStyle}>
                          {proposal.Approvance6 === "true"
                            ? "✅"
                            : proposal.Approvance6 === "false"
                              ? "❌"
                              : "-"}
                        </td>
                        <td style={cellStyle}>
                          {proposal.Approvance7 === "true"
                            ? "✅"
                            : proposal.Approvance7 === "false"
                              ? "❌"
                              : "-"}
                        </td>
                        <td style={cellStyle}>
                          {proposal.Approvance8 === "true"
                            ? "✅"
                            : proposal.Approvance8 === "false"
                              ? "❌"
                              : "-"}
                        </td>
                        <td style={cellStyle}>
                          {proposal.Approvance9 === "true"
                            ? "✅"
                            : proposal.Approvance9 === "false"
                              ? "❌"
                              : "-"}
                        </td>
                        {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
                        <td>
                          <button
                            onClick={() =>
                              selectedBillDetails(proposal.DemandGenerationID)
                            }
                            style={{
                              cursor: "pointer",
                              backgroundColor: "#0098d5",
                              color: "white",
                              border: "none",
                              padding: "5px 10px",
                              borderRadius: "4px",
                            }}
                          >
                            {t("View")}
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div
            className="col-12"
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "3rem",
              alignItems: "center",
            }}
          >
            <div>
              <p>
                {t("Showing")} {currentBills?.length || 0} {t("of")}{" "}
                {proposallist?.length || 0} {t("entries")}
              </p>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <button
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
                style={{
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid lightgrey",
                  cursor: "pointer",
                  fontSize: "24px",
                }}
              >
                &laquo;
              </button>
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid lightgrey",
                  cursor: "pointer",
                  fontSize: "24px",
                  borderLeft: "none",
                }}
              >
                &lt;
              </button>
              <button
                style={{
                  background:
                    "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "24px",
                  width: "3rem",
                  border: "1px solid lightgrey",
                  borderLeft: "none",
                }}
              >
                {currentPage}
              </button>
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid lightgrey",
                  cursor: "pointer",
                  fontSize: "24px",
                  borderLeft: "none",
                }}
              >
                &gt;
              </button>
              <button
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                style={{
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid lightgrey",
                  cursor: "pointer",
                  fontSize: "24px",
                  borderLeft: "none",
                }}
              >
                &raquo;
              </button>
            </div>
          </div>

          {selectedProposal && (
            <div
              onClick={() => setSelectedProposal(null)}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  maxWidth: "600px",
                  width: "90%",
                  maxHeight: "80vh",
                  overflowY: "auto",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                  position: "relative",
                }}
              >
                <h3>{t("Bill Details")}</h3>
                <button
                  onClick={() => setSelectedProposal(null)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    {Object.entries(selectedProposal).map(([key, value]) => (
                      <tr key={key} style={{ borderBottom: "1px solid #ddd" }}>
                        <td
                          style={{
                            fontWeight: "bold",
                            padding: "8px",
                            width: "40%",
                            backgroundColor: "#f0f0f0",
                          }}
                        >
                          {key}
                        </td>
                        <td style={{ padding: "8px" }}>
                          {key == "Bill Number" && value ? value : "--"}
                          {/* Handle Upload Bill Copy link */}
                          {key === "Upload Bill Copy" && value ? (
                            <a
                              href={`${apiurl}/BillCopyDocsImages/${value}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {value}
                            </a>
                          ) : value === null || value === "" ? (
                            "-"
                          ) : (
                            value.toString()
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}

      <div
        className="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          height: "89vh",
          overflowX: "hidden",
          overflowY: "scroll",
          position: "relative",
        }}
      >
        {showspecific === 0 && (
          <div
            style={{
              filter: loading ? "blur(4px)" : "none",
              pointerEvents: loading ? "none" : "auto",
              transition: "0.2s ease",
            }}
          >
            <div className="col-11 m-auto">
              <div className="col-12 ">
                <div
                  className="col-12 px-4 mb-4 mt-3"
                  style={{
                    filter: loading ? "blur(4px)" : "none",
                    pointerEvents: loading ? "none" : "auto",
                    transition: "0.2s ease",
                  }}
                >
                  {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                    <h5 className="fw-bold d-flex align-items-center m-0">
                      <img
                        src="/GR-Approval64.png"
                        alt="Technical Approval"
                        style={{
                          width: "24px",
                          height: "24px",
                          marginRight: "6px",
                        }}
                      />
                      Fund Release From BDS
                    </h5>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-success"
                        onClick={() =>
                          exportTableByClassToExcel(
                            filteredBills,
                            "Bills_Outward.xlsx",
                          )
                        }
                      >
                        {t("Download Excel")}
                      </button>

                      <button
                        className="btn btn-danger"
                        onClick={() =>
                          downloadTableOnlyAsPDF(
                            "BillsOutwardTable",
                            "Bills_Outward.pdf",
                            "Bills Outward Report",
                          )
                        }
                      >
                        {t("Download PDF")}
                      </button>
                    </div>
                  </div>

                  {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "nowrap",
                    }}
                  >
                    {UserRole === "State" && RoleID == 29 && (
                      <select
                        value={typeofData}
                        onChange={(e) => settypeofData(e.target.value)}
                        style={{
                          width: "150px",
                          padding: "8px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <option value="" disabled selected>
                          Choose Data
                        </option>
                        <option value="District">
                          {t(
                            "3054-2419(Roads and bridge repair maintenance program)",
                          )}
                        </option>
                        <option value="State">
                          {t("2515-1238(MLA Representative)")}
                        </option>
                      </select>
                    )}
                    {/* Status */}
                    <select
                      value={statusofData1}
                      onChange={(e) => setstatusofData1(e.target.value)}
                      style={{
                        width: "150px",
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <option value="">{t("All")}</option>
                      <option value="Approved">{t("Approved")}</option>
                      <option value="false">{t("Pending")}</option>
                      <option value="Rejected">{t("Rejected")}</option>
                    </select>

                    {/* District */}
                    {UserRole === "State" && (
                      <div style={{ position: "relative", width: "160px" }}>
                        {/* Dropdown trigger */}
                        <div
                          onClick={() => setOpenDistrict(!openDistrict)}
                          style={{
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            background: "#fff",
                            cursor: "pointer",
                            fontSize: "13px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {SelectedDistrict.length > 0
                            ? SelectedDistrict.join(", ")
                            : "Select District"}
                        </div>

                        {/* Dropdown list */}
                        {openDistrict && (
                          <div
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                              width: "100%",
                              background: "#fff",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                              marginTop: "4px",
                              zIndex: 1000,
                            }}
                          >
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 8px",
                                borderBottom: "1px solid #eee",
                                cursor: "pointer",
                                fontSize: "13px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={toggleAllDistricts}
                                style={{ marginRight: "6px" }}
                              />
                              {t("All Districts")}
                            </label>
                            <div
                              style={{ maxHeight: "150px", overflowY: "auto" }}
                            >
                              {[
                                ...new Set(
                                  AllDistrict?.map((d) => d.District_Marathi),
                                ),
                              ].map((district, index) => (
                                <label
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "6px 8px",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={SelectedDistrict.includes(
                                      district,
                                    )}
                                    onChange={() =>
                                      handleDistrictToggle(district)
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ marginRight: "6px" }}
                                  />
                                  {district}
                                </label>
                              ))}
                            </div>

                            {/* Footer */}
                            <div
                              style={{
                                padding: "6px",
                                textAlign: "right",
                                borderTop: "1px solid #eee",
                              }}
                            >
                              <button
                                onClick={() => setOpenDistrict(false)}
                                style={{
                                  padding: "4px 10px",
                                  fontSize: "12px",
                                  border: "none",
                                  borderRadius: "6px",
                                  background: "#0d6efd",
                                  color: "#fff",
                                  cursor: "pointer",
                                }}
                              >
                                OK
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Search */}
                    <div style={{ position: "relative", width: "220px" }}>
                      <img
                        src="/Search32.png"
                        alt="Search"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          width: "16px",
                          opacity: 0.6,
                        }}
                      />
                      <input
                        type="text"
                        placeholder={t("Search Here")}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 12px 8px 32px",
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          fontSize: "13px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 pb-5">
                  <div
                    className="m-auto mb-3"
                    style={{
                      backgroundColor: "white",
                      padding: "40px 40px",
                      boxShadow: "0px 0px 5px 1px #E4E8EC",
                      borderRadius: "20px",
                      width: "100%",
                      maxWidth: "100%",
                      overflowX: "hidden",
                    }}
                  >
                    <div
                      className="col-12 tableDesign"
                      style={{ background: "#2C78DB", overflowX: "scroll" }}
                    >
                      <table
                        className="m-0 p-0 BillsOutwardTable"
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            <th
                              style={{ minWidth: "70px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Sr.No.")}
                            </th>
                            <th
                              style={{ minWidth: "130px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Demand ID")}
                            </th>
                            <th
                              style={{ minWidth: "130px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Bill Number")}
                            </th>
                            {UserRole === "State" && RoleID != 29 ? (
                              ""
                            ) : (
                              <th
                                style={{ minWidth: "250px", padding: "8px" }}
                                rowSpan={2}
                                colSpan={1}
                              >
                                {t("Head ID")}
                              </th>
                            )}
                            <th
                              style={{ minWidth: "250px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Work Name")}
                            </th>
                            <th
                              style={{ minWidth: "250px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Job ID")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Technical Sanction Number")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Physical Progress(in %)")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("District")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Vendor Name")}
                            </th>
                            {/* <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Work Order UID")}</th> */}
                            <th
                              style={{ minWidth: "250px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Bill Copy")}
                            </th>
                            {/* <th
                              style={{ minWidth: "250px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Demand Copy")}
                            </th> */}
                            <th
                              style={{ minWidth: "250px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Fund release order")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Remark")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Bill Amount")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Net Payable Amount")}
                            </th>
                            <th
                              style={{ minWidth: "150px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Deduction Amount")}
                            </th>
                            <th
                              style={{ minWidth: "190px", padding: "8px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Date")}
                            </th>
                            <th style={{ padding: "8px" }} colSpan={7}>
                              {t("Status")}
                            </th>{" "}
                            {/* changed from 9 to 7 */}
                            {/* <th style={headerStyle} colSpan={1} rowSpan={2}>Details</th> */}
                          </tr>
                        </thead>

                        <tbody>
                          <>
                            {displayedGRS?.length === 0 ? (
                              <tr>
                                <td
                                  colSpan="30"
                                  style={{
                                    textAlign: "center",
                                    padding: "20px",
                                    backgroundColor: "#f9f9f9",
                                    fontSize: "18px"
                                  }}
                                >
                                  {t("No data available")}
                                </td>
                              </tr>
                            ) : (
                              displayedGRS?.map((proposal, index) => {
                                const bgColor =
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                  <tr
                                    style={{ backgroundColor: bgColor }}
                                    key={index}
                                  >
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {indexOfFirstBill + index + 1}
                                    </td>
                                    <td style={{ padding: "8px 8px" , fontSize: "18px"}}>
                                      <span
                                        onClick={() =>
                                          settingshowspecific3(
                                            proposal.DemandGenerationID,
                                          )
                                        }
                                        style={{
                                          color: "#0d6efd",
                                          textDecoration: "underline",
                                          cursor: "pointer",
                                          fontWeight: "500", fontSize: "18px"
                                        }}
                                      >
                                        {proposal.DemandGenerationID}
                                      </span>
                                    </td>
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {proposal.RABillNumber}
                                    </td>
                                    {UserRole === "State" && RoleID != 29 ? (
                                      ""
                                    ) : (
                                      <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                        {proposal.BudgetID}
                                      </td>
                                    )}
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {proposal.ProjectID}
                                    </td>
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {proposal.JOB_ID || "-"}
                                    </td>
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {proposal.BillNumber}
                                    </td>
                                    <td>
                                      <span
                                        style={{
                                          color: "blue",
                                          textDecoration: "underline",
                                          cursor: "pointer"
                                          , fontSize: "18px"
                                        }}
                                        onClick={() =>
                                          openProgressModal(
                                            proposal.Upload,
                                            proposal.Location,
                                          )
                                        }
                                      >
                                        {proposal.physicalValueOfProgress}%
                                      </span>
                                    </td>
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {proposal.District}
                                    </td>
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {proposal.ContractorName}
                                    </td>
                                    {/* <td style={{ padding: '8px 8px' }}>{proposal.WorkOrderUID}</td> */}
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {proposal.UploadBillCopy ? (
                                        <a
                                          href={`${apiurl}/BillCopyDocsImages/${proposal.UploadBillCopy}`}
                                          target="_blank"
                                        >
                                          {proposal.UploadBillCopy}
                                        </a>
                                      ) : (
                                        <p className="fw-bold text-danger my-auto">
                                          {t("No File")}
                                        </p>
                                      )}
                                    </td>
                                    {/* <td style={{ padding: "8px 8px" }}>
                                    {proposal.BillCopy ? (
                                      <a
                                        href={`${apiurl}/BillCopyDocsImages/${proposal.BillCopy}`}
                                        target="_blank"
                                      >
                                        {proposal.BillCopy}
                                      </a>
                                    ) : (
                                      <p className="fw-bold text-danger my-auto">
                                        {t("No File")}
                                      </p>
                                    )}
                                  </td> */}
                                    {/* <td
                                      style={{
                                        fontSize: "12px",
                                        padding: "5px",
                                      }}
                                    >
                                      <button
                                        className="btn py-1 d-flex align-items-center justify-content-center gap-2 mx-auto"
                                        style={{
                                          minHeight: "33px",
                                          minWidth: "100px",
                                          padding: "0.375rem 0.75rem",
                                          fontSize: "0.9rem",
                                          fontWeight: 400,
                                          lineHeight: 1.5,
                                          cursor: "pointer",
                                          background:
                                            "linear-gradient(to right, #38439f, #048ecc)",
                                          color: "white",
                                          borderRadius: "999px",
                                          border: "1px solid transparent",
                                        }}
                                        onClick={() =>
                                          settingshowspecific3(
                                            proposal.DemandGenerationID,
                                          )
                                        }
                                      >
                                        <img
                                          src="/view32.png"
                                          alt="view"
                                          width="15"
                                          height="15"
                                          style={{ verticalAlign: "middle" }}
                                        />
                                        <span style={{ lineHeight: 1 }}>
                                          View{" "}
                                        </span>
                                      </button>
                                    </td> */}
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {proposal.UploadWork ? (
                                        <a
                                          href={`${apiurl}/UploadWorkFiles/${proposal.UploadWork}`}
                                          target="_blank"
                                        >
                                          {proposal.UploadWork}
                                        </a>
                                      ) : (
                                        <p className="fw-bold text-danger my-auto">
                                          {t("No File")}
                                        </p>
                                      )}
                                    </td>
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {proposal.Remark}
                                    </td>
                                                                        <td style={{ padding: "8px 8px", fontSize: "18px"  }}>
  ₹{Number(proposal.BillAmount || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}
</td>

<td style={{ padding: "8px 8px", fontSize: "18px"  }}>
  ₹{Number(proposal.NetPayableAmount || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}
</td>

<td style={{ padding: "8px 8px", fontSize: "18px"  }}>
  ₹{Number(proposal.DeductionAmount || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}
</td>
                                    <td style={{ padding: "8px 8px", fontSize: "18px"  }}>
                                      {proposal.Date
                                        ? new Date(proposal.Date).toLocaleDateString("en-GB")
                                        : "-"}
                                    </td>
                                    <td style={{ padding: "8px 8px", fontSize: "18px" }}>
                                      {String(proposal.Status || "")
                                        .trim()
                                        .toLowerCase() === "completed"
                                        ? "Received"
                                        : proposal.Status || "-"}
                                    </td>
                                  </tr>
                                );
                              })
                            )}
                            <tr
                              style={{
                                fontWeight: "600",
                                backgroundColor: "#f0f0f0",
                                fontSize: "13px",
                              }}
                            >
                              <td
                                colSpan={
                                  UserRole === "State" && RoleID != 29 ? 12 : 13
                                }
                                style={{ textAlign: "left", padding: "8px" }}
                              >
                                {t("Total")}
                              </td>

                              <td style={{ padding: "8px" }}>
                                ₹ {totalBillamt.toLocaleString("en-IN")}
                              </td>
                              <td style={{ padding: "8px" }}>
                                ₹ {totalpayableamt.toLocaleString("en-IN")}
                              </td>
                              <td style={{ padding: "8px" }}>
                                ₹ {totaldeductionamt.toLocaleString("en-IN")}
                              </td>
                              {/* remaining columns */}
                              <td colSpan={UserRole == "State" ? 19 : 20}></td>
                            </tr>
                          </>
                        </tbody>
                      </table>
                    </div>
                    {/* <div className="col-12 mt-4 mb-2">
                    <div className="row">
                      <div className="col-6">
                        <p
                          className="text-gray-600"
                          style={{ fontSize: "14px" }}
                        >
                          {proposallist.length > 0
                            ? `Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, filteredBills.length)} of ${filteredBills.length} entries`
                            : "Showing 0 to 0 of 0 entries"}
                        </p>
                      </div>
                      <div
                        className="col-6"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                        }}
                      >
                        <button
                          onClick={() => setCurrentPage(1)}
                          disabled={currentPage === 1}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid lightgrey",
                            cursor: "pointer",
                            fontSize: "20px",
                            width: "2rem",
                          }}
                        >
                          &laquo;
                        </button>
                        <button
                          onClick={() => setCurrentPage(currentPage - 1)}
                          disabled={currentPage === 1}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid lightgrey",
                            cursor: "pointer",
                            fontSize: "20px",
                            borderLeft: "none",
                            width: "2rem",
                          }}
                        >
                          &lt;
                        </button>
                        <button
                          style={{
                            background:
                              "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                            color: "white",
                            cursor: "pointer",
                            fontSize: "20px",
                            width: "2.4rem",
                            border: "1px solid lightgrey",
                            borderLeft: "none",
                          }}
                        >
                          {currentPage}
                        </button>
                        <button
                          onClick={() => setCurrentPage(currentPage + 1)}
                          disabled={currentPage === totalPages}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid lightgrey",
                            cursor: "pointer",
                            fontSize: "20px",
                            borderLeft: "none",
                            width: "2rem",
                          }}
                        >
                          &gt;
                        </button>
                        <button
                          onClick={() => setCurrentPage(totalPages)}
                          disabled={currentPage === totalPages}
                          style={{
                            backgroundColor: "white",
                            color: "black",
                            border: "1px solid lightgrey",
                            cursor: "pointer",
                            fontSize: "20px",
                            borderLeft: "none",
                            width: "2rem",
                          }}
                        >
                          &raquo;
                        </button>
                      </div>
                    </div>
                  </div> */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "4rem",
                        alignItems: "center",
                      }}
                      className="mt-3"
                    >
                      <div>
                        <p
                          className="text-gray-600"
                          style={{ fontSize: "14px" }}
                        >
                          {proposallist.length > 0
                            ? `Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, filteredBills.length)} of ${filteredBills.length} entries`
                            : "Showing 0 to 0 of 0 entries"}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <GooglePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={setCurrentPage}
                        />

                        <button
                          onClick={() => {
                            setShowAll(!showAll);
                            setCurrentPage(1);
                          }}
                          style={{
                            border: "none",
                            outline: "none",
                            cursor: "pointer",
                            padding: "8px 16px",
                            borderRadius: "20px",
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#fff",
                            background: showAll
                              ? "linear-gradient(135deg, #28a745, #20c997)"
                              : "linear-gradient(135deg, #0067ab, #0098d5)",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                            transition: "all 0.3s ease",
                          }}
                        >
                          {showAll ? "✓ Showing All" : "View All"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {selectedProposal && (
              <div
                onClick={() => setSelectedProposal(null)}
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.84)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 9999,
                }}
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    backgroundColor: "white",
                    padding: "40px 40px",
                    borderRadius: "20px",
                    width: "50%",
                    maxHeight: "90vh",
                    overflow: "hidden",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                    position: "relative",
                  }}
                >
                  <div className="col-12">
                    <div className="col-12  mb-3">
                      <div className="row">
                        <div className="col-6">
                          <h5 className="fw-bold">{t("Bill Details")}</h5>
                        </div>

                        <div
                          className="col-6"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <button
                            onClick={() => setSelectedProposal(null)}
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                              backgroundColor: "red",
                              border: "none",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              fontSize: "24px",
                              fontWeight: "bold",
                              color: "white",
                              lineHeight: 1,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    </div>

                    <div
                      className="col-12"
                      style={{
                        height: "59vh",
                        overflowX: "hidden",
                        overflowY: "scroll",
                        scrollBehavior: "smooth",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          height: "100%",
                          borderCollapse: "collapse",
                        }}
                      >
                        <tbody>
                          {Object.entries(selectedProposal).map(
                            ([key, value], index) => (
                              <>
                                <tr
                                  key={key}
                                  style={{
                                    backgroundColor:
                                      index % 2 === 0 ? "#2B75D5" : "#cce0f9",
                                    border: "1px solid #cce0f9",
                                  }}
                                >
                                  <td
                                    style={{
                                      fontWeight: "bold",
                                      padding: "8px",
                                      width: "40%",
                                      backgroundColor: "#2B75D5",
                                      color: "white",
                                      border: "1px solid #cce0f9",
                                    }}
                                  >
                                    {key}
                                  </td>
                                  <td
                                    style={{
                                      padding: "8px",
                                      color: "black",
                                      backgroundColor:
                                        index % 2 === 0 ? "#E3EBF5" : "#D0DEF1",
                                    }}
                                  >
                                    {/* Handle Upload Bill Copy link */}
                                    {key === "Upload Bill Copy" && value ? (
                                      <a
                                        href={`${apiurl}/BillCopyDocsImages/${value}`}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        {value}
                                      </a>
                                    ) : value === null || value === "" ? (
                                      "-"
                                    ) : (
                                      value.toString()
                                    )}
                                  </td>
                                </tr>
                              </>
                            ),
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {showspecific === 4 && (
          <>
            <div className="col-12 m-auto">
              <div
                className="col-12 m-auto my-15 mb-10 budgetContainer "
                style={{
                  maxHeight: "85vh", // or 700px
                  overflowY: "auto",
                  overflowX: "hidden",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              >
                <div className="m-auto budgetElement">
                  {/* Heading */}

                  {/* TABLE CONTAINER */}
                  <div
                    className="mt-3 d-flex justify-content-between"
                    style={{
                      position: "relative",
                      alignItems: "center",
                      background: "#fff",
                    }}
                  >
                    {/* TITLE – LEFT */}
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <img
                        src="/Bill-files64.png"
                        alt="MAS Slip"
                        width="26"
                        height="26"
                        // style={{ transform: "translateY(9px)", }}
                      />
                      <h5 className="m-0 fw-bold">Bill Slip</h5>
                    </div>
                    {/* BACK BUTTON – TOP RIGHT */}
                    <div className="col-4 pb-3 d-flex justify-content-end gap-2">
                      <button
                        className="btn btn-primary d-flex align-items-center gap-2"
                        style={{
                          borderRadius: "999px",
                          padding: "6px 22px",
                          fontSize: "14px",
                          zIndex: 10,
                        }}
                        onClick={exportBillSlipPDF}
                        disabled={exportingBillSlipPDF}
                      >
                        {exportingBillSlipPDF ? "Exporting..." : "Export PDF"}
                      </button>
                      <button
                        className="btn btn-danger d-flex align-items-center gap-2"
                        style={{
                          top: "12px",
                          right: "12px",
                          borderRadius: "999px",
                          padding: "6px 22px",
                          fontSize: "14px",
                          zIndex: 10,
                        }}
                        onClick={BackFunction}
                      >
                        {/* <img
                        src={Back32}
                        alt="back"
                        width="14"
                        height="14"
                        // style={{ filter: "brightness(0) invert(1)" }}
                      /> */}
                        Back
                      </button>
                    </div>
                  </div>

                  {/* ================= HEADER ================= */}
                  <div ref={billSlipRef}>
                    <div
                      className="text-center text-white py-3"
                      style={{
                        background: "linear-gradient(90deg, #2b4ea1, #0aa2d6)",
                      }}
                    >
                      <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                        Zila Parishad - {selectedBillData.District}
                      </div>

                      {/* <div style={{ fontSize: "15px", fontWeight: "bold" }}>
                    प्रशासकीय मंजुरी वर्ष - 2026-2027
                  </div>

                  <div>विभाग - EXE.ENGINEER ZP Division {selectedBillData.Division}</div>

                  <div>उप-विभाग - {selectedBillData.District}</div>

                  <div class="small">
                    या तपशीलवार शीर्षाचे देयकासाठी आवश्यक असेल तिथे वित्त
                    विभागाचा अनौपचारिक संदर्भ तपासावा.
                  </div> */}
                    </div>
                    <div className="border border-dark p-1">
                      <table
                        className="table mb-0"
                        style={{ fontSize: "14px", border: "none" }}
                      >
                        <tbody>
                          {/* <tr>
                          <td className='text-start'>
                            <span>UserName :</span>

                          </td>
                          <td className='text-end'>
                            <span>DateTime : </span>
                          </td>
                        </tr> */}
                          <tr>
                            <td
                              colSpan={2}
                              className="fw-bold text-center fs-6 p-1"
                            >
                              {" "}
                              Bill Slip for RDD
                            </td>
                          </tr>
                          {[
                            [
                              "User Name",
                              `${selectedBillData.UploadedBy ?? "-"}`,
                            ],
                            [
                              "Demand ID",
                              `${selectedBillData.DemandGenerationID ?? "-"}`,
                            ],
                            [
  "Bill Date",
  selectedBillData.UploadedOn
    ? new Date(selectedBillData.UploadedOn).toLocaleDateString("en-GB")
    : "-",
],
                            [
                              "Head Code",
                              `${selectedBillData.BudgetID ?? "-"}`,
                            ],
                            [
                              "Work Name",
                              `${selectedBillData.ProjectID ?? "-"}`,
                            ],
                            [
                              "Work Approved Year",
                              `${selectedBillData.ProposalYear ?? "-"}`,
                            ],
                            [
  "Work order date",
  selectedBillData.WorkOrderDate
    ? new Date(selectedBillData.WorkOrderDate).toLocaleDateString("en-GB")
    : "-",
],
[
  "Work Approved Amount",
  selectedBillData.ApprovedWorkAmount != null
    ? `₹${Number(selectedBillData.ApprovedWorkAmount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-",
],
[
  "Gross Bill Amount",
  selectedBillData.BillAmount != null
    ? `₹${Number(selectedBillData.BillAmount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-",
],
                            [
                              "R.A.Bill No:",
                              `${selectedBillData.RABillNumber ?? "-"}`,
                            ],

                            [
                              "Invoice Bill No",
                              `${selectedBillData.InvoiceNo ?? "-"}`,
                            ],
                          ].map(([label, value], index) => (
                            <tr
                              key={index}
                              style={{ border: "1.5px solid #1190CA" }}
                            >
                              <td
                                className="text-start"
                                style={{
                                  width: "30%",
                                  backgroundColor: "#EAF3FB",
                                  fontWeight: 500,
                                  padding: "6px 10px",
                                  borderRight: "1.5px solid #1190CA",
                                }}
                              >
                                {label}
                              </td>

                              <td
                                className="text-start"
                                style={{
                                  width: "70%",
                                  padding: "6px 10px",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                {value}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <table
                        className="mt-1"
                        style={{
                          borderCollapse: "collapse",
                          border: "1px solid #000",
                        }}
                      >
                        <tbody>
                          <tr className="border border-dark">
  <td
    className="text-start border border-dark"
    style={{ width: "30%" }}
  >
    Bill Amount (₹)
  </td>

  <td
    className="text-start border border-dark"
    style={{ width: "23%" }}
  >
    Deduction Amount (₹)
  </td>

  <td
    className="text-start border border-dark"
    style={{ width: "24%" }}
  >
    Net Payable (₹)
  </td>
</tr>
                          <tr>
  <td className="text-start border border-dark">
    {selectedBillData.BillAmount != null &&
    selectedBillData.BillAmount !== ""
      ? `₹${Number(selectedBillData.BillAmount).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "-"}
  </td>

  <td className="text-start border border-dark">
    {selectedBillData.DeductionAmount != null &&
    selectedBillData.DeductionAmount !== ""
      ? `₹${Number(selectedBillData.DeductionAmount).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "-"}
  </td>

  <td className="text-start border border-dark">
    {selectedBillData.NetPayableAmount != null &&
    selectedBillData.NetPayableAmount !== ""
      ? `₹${Number(selectedBillData.NetPayableAmount).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "-"}
  </td>
</tr>
                        </tbody>
                      </table>

                      {/* Vendor Details */}
                      <table
                        className="mt-2"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "14px",
                        }}
                      >
                        <tbody>
                          {/* Section Title */}
                          <tr
                            style={{
                              border: "1.5px solid #1190CA",
                              backgroundColor: "#EAF3FB",
                            }}
                          >
                            <td
                              colSpan="6"
                              style={{
                                padding: "8px 10px",
                                fontWeight: 600,
                                textAlign: "center",
                              }}
                            >
                              Vendor Details
                            </td>
                          </tr>

                          {/* Column Headers */}
                          <tr style={{ border: "1.5px solid #1190CA" }}>
                            <td
                              style={{
                                padding: "6px 8px",
                                fontWeight: 500,
                                backgroundColor: "#1190CA",
                                color: "white",
                              }}
                            >
                              Vendor Name
                            </td>
                            {/* <td style={{ padding: "6px 8px", fontWeight: 500, backgroundColor: "#1190CA", color: "white" }}>PAN Number</td> */}
                            <td
                              style={{
                                padding: "6px 8px",
                                fontWeight: 500,
                                backgroundColor: "#1190CA",
                                color: "white",
                              }}
                            >
                              IFSC Code
                            </td>
                            <td
                              style={{
                                padding: "6px 8px",
                                fontWeight: 500,
                                backgroundColor: "#1190CA",
                                color: "white",
                              }}
                            >
                              Branch Name
                            </td>
                            <td
                              style={{
                                padding: "6px 8px",
                                fontWeight: 500,
                                backgroundColor: "#1190CA",
                                color: "white",
                              }}
                            >
                              Bank Name
                            </td>
                            <td
                              style={{
                                padding: "6px 8px",
                                fontWeight: 500,
                                backgroundColor: "#1190CA",
                                color: "white",
                              }}
                            >
                              Account Number
                            </td>
                           <td
  style={{
    padding: "6px 8px",
    fontWeight: 500,
    backgroundColor: "#1190CA",
    color: "white",
  }}
>
  Amount (₹)
</td>
                          </tr>

                          {fetchSpecificDemandDeductionDetail &&
                            fetchSpecificDemandDeductionDetail
                              .filter(
                                (val) =>
                                  val.TypeOfAmount == "Total Amount Payable",
                              )
                              .map((val, index) => {
                                return (
                                  <>
                                    <tr
                                      style={{ border: "1.5px solid #1190CA" }}
                                      key={index}
                                    >
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          backgroundColor: "white",
                                        }}
                                      >
                                        {val.Vendor_Company_Name}
                                      </td>
                                      {/* <td style={{ padding: "6px 8px", backgroundColor: "white" }}>{val.Vendor_Company_Name}</td> */}
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          backgroundColor: "white",
                                        }}
                                      >
                                        {val.Bank_IFSC_Code}
                                      </td>
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          backgroundColor: "white",
                                        }}
                                      >
                                        {val.Branch_Name}
                                      </td>
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          backgroundColor: "white",
                                        }}
                                      >
                                        {val.BANK_NAME}
                                      </td>
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          backgroundColor: "white",
                                        }}
                                      >
                                        {val.Bank_Account_Number}
                                      </td>
                                      <td
  style={{
    padding: "6px 8px",
    backgroundColor: "white",
  }}
>
  {val.TotalAmount != null && val.TotalAmount !== ""
    ? `₹${Number(val.TotalAmount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-"}
</td>
                                    </tr>
                                  </>
                                );
                              })}

                          {/* <tr style={{ border: "1.5px solid #1190CA" }}>
                          <td
                          >
                            Shivsai Construction
                          </td>
                          <td className='border border-dark'>AKIPS8199N</td>
                          <td className='border border-dark'>MAHB0001302</td>
                          <td className='border border-dark'>BANK OF MAHARASHTRA, GHODBUNDER ROAD</td>
                          <td className='border border-dark'>2,43,991.0</td>
                          <td className='border border-dark'> 2,43,991.0</td>
                        </tr> */}

                          {/* Total */}
                          <tr style={{ border: "1.5px solid #1190CA" }}>
                            <td
                              style={{
                                padding: "6px 8px",
                                backgroundColor: "#EAF3FB",
                                fontWeight: 500,
                              }}
                              colSpan={5}
                            >
                              Total
                            </td>
                           <td className="border border-dark">
  {selectedBillData.NetPayableAmount != null &&
  selectedBillData.NetPayableAmount !== ""
    ? `₹${Number(selectedBillData.NetPayableAmount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-"}
</td>
                          </tr>
                        </tbody>
                      </table>

                      <table
                        className="my-2"
                        style={{ width: "100%", borderCollapse: "collapse" }}
                      >
                        <thead>
                          <tr
                            style={{
                              border: "1.5px solid #1190CA",
                              backgroundColor: "#EAF3FB",
                            }}
                          >
                            <td
                              colSpan="6"
                              style={{
                                padding: "8px 10px",
                                fontWeight: 600,
                                textAlign: "center",
                              }}
                            >
                              Deduction Amount Details
                            </td>
                          </tr>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                            }}
                          >
                            <th style={{ minWidth: "60px", padding: "8px" }}>
                              Sr No
                            </th>
                            <th style={{ minWidth: "60px", padding: "8px" }}>
                              Deduction Type
                            </th>
                            <th style={{ minWidth: "60px", padding: "8px" }}>
                              Deduction Amount{" "}
                            </th>
                            {/* <th style={{ minWidth: "60px", padding: "8px" }}>
                          Vendor Name
                        </th> */}
                            <th style={{ minWidth: "60px", padding: "8px" }}>
                              Account Number
                            </th>
                            <th style={{ minWidth: "60px", padding: "8px" }}>
                              Bank Name
                            </th>
                            <th style={{ minWidth: "60px", padding: "8px" }}>
                              IFSC
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {fetchSpecificDemandDeductionDetail.filter(
                            (val) => val.TypeOfAmount != "Total Amount Payable",
                          )?.length == 0 ? (
                            <tr>
                              <td
                                colSpan="30"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                No data available
                              </td>
                            </tr>
                          ) : (
                            fetchSpecificDemandDeductionDetail
                              .filter(
                                (val) =>
                                  val.TypeOfAmount != "Total Amount Payable",
                              )
                              .map((technicalInwards, index) => {
                                const bgColor =
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                  <tr
                                    className="px-3"
                                    key={index}
                                    style={{
                                      borderBottom: "1px solid #3b409e",
                                      backgroundColor: bgColor,
                                    }}
                                  >
                                    <td
                                      style={{
                                        fontSize: "12px",
                                        padding: "5px",
                                      }}
                                    >
                                      {index + 1}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "12px",
                                        padding: "5px",
                                      }}
                                    >
                                      {technicalInwards.TypeOfAmount}
                                    </td>
                                    <td
  style={{
    fontSize: "12px",
    padding: "5px",
  }}
>
  {technicalInwards.TotalAmount != null &&
  technicalInwards.TotalAmount !== ""
    ? `₹${Number(technicalInwards.TotalAmount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-"}
</td>
                                    {/* <td
                                  style={{ fontSize: "12px", padding: "5px" }}
                                >
                                  {technicalInwards.Vendor_Company_Name}
                                </td> */}
                                    <td
                                      style={{
                                        fontSize: "12px",
                                        padding: "5px",
                                      }}
                                    >
                                      {technicalInwards.Bank_Account_Number}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "12px",
                                        padding: "5px",
                                      }}
                                    >
                                      {technicalInwards.Bank_Name}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "12px",
                                        padding: "5px",
                                      }}
                                    >
                                      {technicalInwards.Bank_IFSC_Code}
                                    </td>
                                  </tr>
                                );
                              })
                          )}

                          <tr
                            style={{
                              border: "1.5px solid #1190CA",
                              fontWeight: 600,
                              background: "white",
                            }}
                          >
                            <td
                              colSpan="2"
                              style={{ padding: "6px 8px", textAlign: "right" }}
                            >
                              Total
                            </td>
                            <td style={{ padding: "6px 8px" }}>
  {selectedBillData.DeductionAmount != null &&
  selectedBillData.DeductionAmount !== ""
    ? `₹${Number(selectedBillData.DeductionAmount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "-"}
</td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Signature grid */}
                      <table style={footerTitleStyle}>
                        <tbody>
                          <tr>
                            <td style={footerTitleTdStyle}>मागील देयक तपशील</td>
                          </tr>
                        </tbody>
                      </table>

                      <table style={remarksTableStyle}>
                        <tbody>
                          <tr>
                            <td style={remarksTableTdStyle}>
                              प्रमाणित करण्यात येते की मा देयकाद्वारे आहारीत
                              करण्यात येत असलेली संपूर्ण रक्कम याच जिल्हात खर्च
                              करण्यात येणार आहे.
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <table style={remarksTableStyle}>
                        <tbody>
                          <tr>
                            <td style={remarksTableTdStyle}>
                              स्वाक्षरी आहरण व संवितरण अधिकारी
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <table style={instructionTableStyle}>
                        <tbody>
                          <tr>
                            <td style={instructionTableTdStyle}>
                              दुबार देयक प्रतिबंध नोंदवही तपासणीच्या आधारे
                              प्रमाणित करण्यात येते की या देयकात नमूद केलेल्या
                              अधिकाऱ्याचे कर्मचाऱ्याचे / पुरवठादाराचे तसेच त्यात
                              नमूद केलेल्या बाबीचे / कालावधीचे देयक यापूर्वी
                              ग्रामविकास विभाग मुबई येथे सादर करण्यात आले
                              नव्हते. प्रमाणित करण्यात येते की वरील मागणी ही
                              महाराष्ट्र कोषागार नियम / मुंबई वित्तीय नियम /
                              महाराष्ट्र आकस्मिक खर्च नियम व वेळोवेळी विहित
                              केलेल्या आदेशांच्या आधारे तयार करण्यात आली आहे.
                              श्री. किंवा श्रीमती ______________________________
                              यांना सदर देयकाची रक्कम/किंवा अपेक्षित देयक प्रदान
                              करीता प्राधिकृत करण्यात आले असून त्यांची स्वाक्षरी
                              खालीलप्रमाणे आहे.
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      {/* <table style={signatureTableStyle}>
  <tbody>
    <tr>
      <td style={signatureTableTdStyle}>
        <div style={signBoxStyle}>
          <div style={signSpaceStyle}></div>
          <div style={signTitleStyle}>
            संदेश वाहकाची स्वाक्षरी
          </div>
        </div>
      </td>

      <td style={signatureTableTdStyle}></td>

      <td style={signatureTableTdStyle}>
        <div style={signBoxStyle}>
          <div style={signSpaceStyle}></div>

          <div style={signTitleStyle}>
            सही
          </div>

          <div style={officerStyle}>
            DY Secretary / Controller Officer
          </div>

          <div style={officerMarathiStyle}>
            आहरण व संवितरण अधिकारी
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table> */}

                      {/* Footer */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {showProgressModal && (
          <div
            className="modal d-block"
            tabIndex="-1"
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Physical Progress Images</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowProgressModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    {progressData?.length > 0 ? (
                      progressData.map((item, index) => (
                        <div className="col-md-4 mb-3" key={index}>
                          <div
                            style={{
                              border: "1px solid #ddd",
                              borderRadius: "10px",
                              padding: "10px",
                              background: "#fff",
                            }}
                          >
                            <img
                              src={`${apiurl}/UploadProgressDocsImages/${item?.image}`}
                              alt="Document"
                              style={{
                                width: "120px",
                                cursor: "pointer",
                                maxHeight: "250px",
                                objectFit: "contain",
                              }}
                              onClick={() => {
                                setSelectedImageIndex(index);
                                setSelectedImage(
                                  `${apiurl}/UploadProgressDocsImages/${item.image}`,
                                );
                                setShowImageModal(true);
                              }}
                            />
                            <div
                              style={{
                                marginTop: "10px",
                                fontSize: "14px",
                                lineHeight: "1.7",
                              }}
                            >
                              <div>
                                📍 <strong>Latitude:</strong>{" "}
                                {item.location?.latitude || "-"}
                              </div>
                              <div>
                                📍 <strong>Longitude:</strong>{" "}
                                {item.location?.longitude || "-"}
                              </div>
                              <div>
                                📅 <strong>Date:</strong>{" "}
                                {item.location?.date || "-"}
                              </div>
                              <div>
                                🕒 <strong>Time:</strong>{" "}
                                {item.location?.time || "-"}
                              </div>
                              <div>
                                ⛰️ <strong>Elevation:</strong>{" "}
                                {item.location?.elevation || "-"} m
                              </div>
                              <div>
                                🎯 <strong>Accuracy:</strong>{" "}
                                {item.location?.accuracy || "-"} m
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No Images Found</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showImageModal && (
          <div
            onClick={() => setShowImageModal(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImageIndex(
                  (selectedImageIndex - 1 + progressData.length) %
                    progressData.length,
                );
              }}
              style={{
                position: "absolute",
                left: "20px",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "30px",
                background: "rgba(0,0,0,0.5)",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                cursor: "pointer",
                zIndex: 10001,
              }}
            >
              ❮
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowImageModal(false);
              }}
              style={{
                position: "absolute",
                top: "20px",
                right: "30px",
                fontSize: "30px",
                color: "#fff",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                zIndex: 10001,
              }}
            >
              ×
            </button>

            <img
              src={`${apiurl}/UploadProgressDocsImages/${progressData[selectedImageIndex]?.image}`}
              alt="Preview"
              onClick={(e) => e.stopPropagation()}
              style={{
                maxWidth: "85%",
                maxHeight: "85%",
                borderRadius: "8px",
                objectFit: "contain",
              }}
            />

            <div
              style={{
                position: "absolute",
                bottom: "20px",
                color: "#fff",
                fontSize: "16px",
                fontWeight: "bold",
                background: "rgba(0,0,0,0.5)",
                padding: "6px 12px",
                borderRadius: "20px",
              }}
            >
              {selectedImageIndex + 1} / {progressData.length}
            </div>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedImageIndex(
                  (selectedImageIndex + 1) % progressData.length,
                );
              }}
              style={{
                position: "absolute",
                right: "20px",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "30px",
                background: "rgba(0,0,0,0.5)",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                cursor: "pointer",
                zIndex: 10001,
              }}
            >
              ❯
            </button>
          </div>
        )}

        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.4)",
              backdropFilter: "blur(2px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="Adminloader"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewDemandGeneration;

//--> old code
// import React, { useState, useEffect, useContext, useRef } from "react";
// import AdminContext from "../../../StateContext/Application";
// // import { apiurl } from '../../../../path';
// import { Link } from "react-router-dom";
// // import "./rejectpanel.css";
// import {
//   Back32,
//   Cancel32,
//   ProposalCreation32,
//   submit,
// } from "../../../../../public/LoginImages/importimages";
// import { apiurl } from "../../../../../path";
// import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import GooglePagination from "../../../styles/GooglePagination";

// const ViewDemandGeneration = () => {
//   const { language, toggleLanguage, t } = useLanguage();
//   const context = useContext(AdminContext);
//   const { GetBudgetHeadInfo, TechnicalOutwards, Usermenu, Getyears } = context;

//   const [technicalInwards, setTechnicalInwards] = useState([]);
//   const [selectedBills, setSelectedBills] = useState([]);
//   const [filteredBills, setFilteredBills] = useState([]);
//   const [selectedProposal, setSelectedProposal] = useState(null);
//   const [proposallist, setProposalList] = useState([]);

//   const [UserRole, setUserRole] = useState("");
//   const [AllDistrict, setAllDistrict] = useState([]);
//   const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
//   const [SelectedDistrict, setSelectedDistrict] = useState([]);
//   // const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] = useState("");
//   const [statusofData, setstatusofData] = useState("Sent to Bank");
//   const [statusofData1, setstatusofData1] = useState("");
//   const [RoleID, setroleID] = useState(null);
//   const [typeofData, settypeofData] = useState("District");
//   const [openDistrict, setOpenDistrict] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showAll, setShowAll] = useState(false);
//   const [selectedDemandID, setSelectedDemandID] = useState();
//   const billsPerPage = showAll ? filteredBills.length : 10;
//   const [searchTerm, setSearchTerm] = useState("");
//   const budgetEstimation = proposallist;

//   const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//   const indexOfLastBill = currentPage * billsPerPage;
//   const indexOfFirstBill = indexOfLastBill - billsPerPage;
//   const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

//   const [exportingPDF, setExportingPDF] = useState(false);
//   const [loading, setloading] = useState(false);
//   const displayedGRS = exportingPDF ? filteredBills : currentBills;

//   const [
//     fetchSpecificDemandDeductionDetail,
//     setfetchSpecficDemandDeductionDetail,
//   ] = useState([]);
//   const [selectedBillData, setselectedBillData] = useState({});
//   const [showspecific, setShowSpecific] = useState(0);

//   const billSlipRef = useRef(null);
//   const [userDistrict, setuserDistrict] = useState({});

//   const [exportingBillSlipPDF, setExportingBillSlipPDF] = useState(false);

//   const headerStyle = {
//     padding: "12px 16px",
//     whiteSpace: "nowrap",
//     borderRight: "1px solid #e0e0e0",
//     textTransform: "capitalize",
//   };
//   const commonWidth = `${100 / 7}%`; // whatever the current width of Department Auditor looks like

//   const headerStyle1 = {
//     width: commonWidth,
//     padding: "12px 16px",
//     whiteSpace: "nowrap",
//     borderRight: "1px solid #e0e0e0",
//     textTransform: "capitalize",
//   };

//   const cellStyle = {
//     width: commonWidth, // 100% / 7 columns
//     padding: "8px",
//     textAlign: "center",
//     //   whiteSpace: 'nowrap'
//   };

//   const getTechnicalInwardsList = async () => {
//     let data = await GetBudgetHeadInfo("All", "GetDemandGenerationList");
//     let data1 = await TechnicalOutwards("FundBDS");
//     const { status, message, Tabletype } = data1;

//     if (status) {
//       setTechnicalInwards(message);
//       setProposalList(message);
//       // setFilteredBills(message);
//       setUserRole(Tabletype);
//     } else {
//       alert(message);
//     }
//   };
//   const getmenu = async () => {
//     try {
//       const data = await Usermenu();
//       if (!data || typeof data !== "object") {
//         console.error("Invalid data:", data);
//         return;
//       }
//       const roleID = data?.Data?.RoleID;
//       setroleID(roleID);
//       console.log("sffdsf", data?.Data);
//     } catch (error) {
//       console.error("Error in AdminNavbar getmenu:", error);
//     }
//   };
//   useEffect(() => {
//     getTechnicalInwardsList();
//     getmenu();
//   }, []);

//   const allDistricts = [
//     ...new Set(AllDistrict?.map((d) => d.District_Marathi)),
//   ];
//   const isAllSelected = SelectedDistrict.length === allDistricts.length;

//   const toggleAllDistricts = () => {
//     setSelectedDistrict(isAllSelected ? [] : allDistricts);
//   };
//   const handleDistrictToggle = (district) => {
//     setSelectedDistrict((prev) =>
//       prev.includes(district)
//         ? prev.filter((d) => d !== district)
//         : [...prev, district],
//     );
//   };

//   useEffect(() => {
//     let filtered = [...technicalInwards];
//     console.log("All data ---> ", technicalInwards);
//     if (typeofData === "District" && RoleID === 29) {
//       filtered = filtered.filter(
//         (item) =>
//           item.BudgetID ===
//           "3054-2419(Roads and bridge repair maintenance program)",
//       );
//       console.log("filtered Date 3054", filtered);
//     } else if (typeofData === "State" && RoleID === 29) {
//       filtered = filtered.filter(
//         (item) => item.BudgetID === "2515-1238(MLA Representative)",
//       );
//     }
//     // 🔹 Filter by District (MULTI-SELECT)
//     if (SelectedDistrict?.length > 0) {
//       filtered = filtered.filter((item) =>
//         SelectedDistrict.includes(item.District),
//       );
//     }

//     // 🔹 Filter by Approval / Status
//     if (statusofData1) {
//       if (statusofData1 === "false") {
//         filtered = filtered.filter(
//           (item) =>
//             item.Approvance1 === "false" ||
//             item.Approvance2 === "false" ||
//             item.Approvance3 === "false" ||
//             item.Approvance4 === "false" ||
//             item.Approvance5 === "false" ||
//             item.Approvance6 === "false" ||
//             item.Approvance9 === "false" ||
//             item.Approvance8 === "false" ||
//             item.Approvance9 === "false",
//         );
//       } else if (statusofData1 === "Approved") {
//         // ✅ Added block
//         filtered = filtered.filter(
//           (item) =>
//             item.Approvance1 === "true" &&
//             item.Approvance2 === "true" &&
//             item.Approvance3 === "true" &&
//             item.Approvance4 === "true" &&
//             item.Approvance5 === "true" &&
//             item.Approvance6 === "true" &&
//             item.Approvance9 === "true" &&
//             item.Approvance8 === "true" &&
//             item.Approvance9 === "true",
//         );
//       } else if (statusofData1 === "Rejected") {
//         filtered = filtered.filter((item) => item.Status === "Rejected");
//       }
//     }

//     console.log("Filter data ---> ", filtered);

//     // 🔹 Search Filter
//     if (searchTerm.trim()) {
//       const lower = searchTerm.toLowerCase();
//       filtered = filtered.filter((bill) =>
//         Object.values(bill).some((val) =>
//           String(val ?? "")
//             .toLowerCase()
//             .includes(lower),
//         ),
//       );
//     }

//     setFilteredBills(filtered);
//     setCurrentPage(1);
//   }, [
//     statusofData1,
//     searchTerm,
//     technicalInwards,
//     SelectedDistrict,
//     typeofData,
//   ]);

//   const selectedBillDetails = (BillID) => {
//     const result = budgetEstimation
//       .filter((item) => item.DemandGenerationID == BillID)
//       .map((item) => ({
//         "Bill ID": item.DemandGenerationID,
//         "Bill Number": item.RABillNumber,
//         "Proposal ID": item.ProjectID,
//         "Head ID": item.BudgetID,
//         District: item.District,
//         "Contractor Name": item.ContractorName,
//         "Work Order UID": item.WorkOrderUID,
//         "Upload Bill Copy": item.UploadBillCopy,
//         Remark: item.Remark,
//         "Bill Amount": item.BillAmount,
//         "Net Payable Amount": item.NetPayableAmount,
//         "Deduction Amount": item.DeductionAmount,
//         Date: new Date(item.Date).toLocaleString(),
//       }));

//     console.log("------------------", result);
//     setSelectedProposal(result[0]);
//   };

//   const FetchGramPanachayatInfo = async () => {
//     try {
//       let res = await GetBudgetHeadInfo("null", "AllDistrict");
//       // console.log("Data i get:: ", res);
//       setAllDistrict(res);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     FetchGramPanachayatInfo();
//   }, []);

//   const totalBillamt = filteredBills?.reduce((sum, item) => {
//     const amount = Number(item?.BillAmount);
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);
//   const totalpayableamt = filteredBills?.reduce((sum, item) => {
//     const amount = Number(item?.NetPayableAmount);
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);
//   const totaldeductionamt = filteredBills?.reduce((sum, item) => {
//     const amount = Number(item?.DeductionAmount);
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);

//     const pagetotalBillamt = currentBills?.reduce((sum, item) => {
//     const amount = Number(item?.BillAmount);
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);
//   const pagetotalpayableamt = currentBills?.reduce((sum, item) => {
//     const amount = Number(item?.NetPayableAmount);
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);
//   const pagetotaldeductionamt = currentBills?.reduce((sum, item) => {
//     const amount = Number(item?.DeductionAmount);
//     return sum + (isNaN(amount) ? 0 : amount);
//   }, 0);


//   const exportTableByClassToExcel = async (
//     bills,
//     filename = "Bills_Outward.xlsx",
//   ) => {
//     if (!bills || bills.length === 0) {
//       alert("No data available");
//       return;
//     }

//     setloading(true);
//     await new Promise((resolve) => setTimeout(resolve, 1000));
//     try {
//       const getStatus = (val) =>
//         val === "true" ? "✓" : val === "false" ? "✕" : "-";

//       const excelData = bills.map((proposal, index) => ({
//         "Sr.No.": index + 1,
//         "Bill ID": proposal.DemandGenerationID,
//         "Bill Number": proposal.RABillNumber,
//         "Head ID": proposal.BudgetID,
//         "Work Name": proposal.ProjectID,
//         "Technical Sanction Number": proposal.BillNumber,
//         "Physical Progress(in %)": proposal.physicalValueOfProgress,
//         District: proposal.District,
//         "Vendor Name": proposal.ContractorName,
//         "Upload Bill Copy": proposal.UploadBillCopy || "No File",
//         "Bill Copy": proposal.BillCopy || "No File",
//         Remark: proposal.Remark || "",
//         "Bill Amount": proposal.BillAmount || 0,
//         "Net Payable Amount": proposal.NetPayableAmount || 0,
//         "Deduction Amount": proposal.DeductionAmount || 0,
//         Date: proposal.Date ? new Date(proposal.Date).toLocaleString() : "",
//         "Department Auditor": getStatus(proposal.Approvance1),
//         "Department HOD(EE)": getStatus(proposal.Approvance2),
//         "FD Auditor": getStatus(proposal.Approvance3),
//         "FD AAO": getStatus(proposal.Approvance4),
//         "FD AO": getStatus(proposal.Approvance5),
//         "Deputy CAFO": getStatus(proposal.Approvance6),
//         CAFO: getStatus(proposal.Approvance9),
//       }));

//       /* 🔢 TOTAL ROW */
//       const totalRow = {
//         "Sr.No.": "Total",
//         "Bill ID": "",
//         "Bill Number": "",
//         "Head ID": "",
//         "Work Name": "",
//         "Technical Sanction Number": "",
//         "Physical Progress(in %)": "",
//         District: "",
//         "Vendor Name": "",
//         "Upload Bill Copy": "",
//         "Bill Copy": "",
//         Remark: "",
//         "Bill Amount": bills.reduce(
//           (sum, b) => sum + Number(b.BillAmount || 0),
//           0,
//         ),
//         "Net Payable Amount": bills.reduce(
//           (sum, b) => sum + Number(b.NetPayableAmount || 0),
//           0,
//         ),
//         "Deduction Amount": bills.reduce(
//           (sum, b) => sum + Number(b.DeductionAmount || 0),
//           0,
//         ),
//         Date: "",
//         "Department Auditor": "",
//         "Department HOD(EE)": "",
//         "FD Auditor": "",
//         "FD AAO": "",
//         "FD AO": "",
//         "Deputy CAFO": "",
//         CAFO: "",
//       };

//       excelData.push(totalRow);

//       const worksheet = XLSX.utils.json_to_sheet(excelData);

//       /* Column width */
//       worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({
//         wch: 22,
//       }));

//       /* Freeze header */
//       worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

//       /* Filter */
//       worksheet["!autofilter"] = {
//         ref: XLSX.utils.encode_range({
//           s: { r: 0, c: 0 },
//           e: {
//             r: excelData.length,
//             c: Object.keys(excelData[0]).length - 1,
//           },
//         }),
//       };

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Bills");
//       XLSX.writeFile(workbook, filename);
//     } catch (error) {
//       console.error("Excel Export Error:", error);
//     } finally {
//       setloading(false); // ✅ ALWAYS stop loader
//     }
//   };

//   const downloadTableOnlyAsPDF = async (
//     tableClass,
//     filename,
//     title,
//     chunkSize = 500, // 🔥 300–500 recommended
//   ) => {
//     const originalTable = document.querySelector(`.${tableClass}`);
//     if (!originalTable) {
//       setExportingPDF(false);
//       return;
//     }

//     setloading(true);
//     setExportingPDF(true);

//     // Allow loader to render first
//     await new Promise((resolve) => setTimeout(resolve, 600));

//     try {
//       const originalRows = originalTable.querySelectorAll("tbody tr");
//       const totalRows = originalRows.length;

//       if (!totalRows) {
//         setloading(false);
//         setExportingPDF(false);
//         return;
//       }

//       for (let start = 0; start < totalRows; start += chunkSize) {
//         const end = Math.min(start + chunkSize, totalRows);

//         // 🔥 Clone table cleanly
//         const tableClone = originalTable.cloneNode(true);
//         const rows = tableClone.querySelectorAll("tbody tr");

//         // Remove rows outside current chunk
//         rows.forEach((row, index) => {
//           if (index < start || index >= end) {
//             row.remove();
//           }
//         });

//         // Hide cloned table from view
//         tableClone.style.position = "absolute";
//         tableClone.style.left = "-9999px";
//         tableClone.style.top = "0";
//         document.body.appendChild(tableClone);

//         const pdf = new jsPDF("p", "mm", "a4");
//         const pageWidth = pdf.internal.pageSize.getWidth();
//         const pageHeight = pdf.internal.pageSize.getHeight();

//         const topMargin = 25;
//         const sideMargin = 10;
//         const bottomMargin = 15;

//         pdf.setFontSize(16);
//         pdf.setFont("helvetica", "bold");
//         pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
//           align: "center",
//         });

//         const canvas = await html2canvas(tableClone, {
//           scale: 1,
//           useCORS: true,
//           backgroundColor: "#2C78DB",
//         });

//         const imgWidth = pageWidth - sideMargin * 2;
//         const pxToMm = imgWidth / canvas.width;

//         const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
//         const usablePageHeightPx = usablePageHeightMm / pxToMm;

//         let renderedHeight = 0;
//         let pageNumber = 0;

//         while (renderedHeight < canvas.height) {
//           const sliceHeight = Math.min(
//             usablePageHeightPx,
//             canvas.height - renderedHeight,
//           );

//           const pageCanvas = document.createElement("canvas");
//           const context = pageCanvas.getContext("2d");

//           pageCanvas.width = canvas.width;
//           pageCanvas.height = sliceHeight;

//           context.drawImage(
//             canvas,
//             0,
//             renderedHeight,
//             canvas.width,
//             sliceHeight,
//             0,
//             0,
//             canvas.width,
//             sliceHeight,
//           );

//           const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

//           if (pageNumber > 0) pdf.addPage();

//           pdf.addImage(
//             imgData,
//             "JPEG",
//             sideMargin,
//             topMargin,
//             imgWidth,
//             sliceHeight * pxToMm,
//           );

//           renderedHeight += sliceHeight;
//           pageNumber++;
//         }

//         pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

//         document.body.removeChild(tableClone);

//         // Small delay prevents UI freezing
//         await new Promise((resolve) => setTimeout(resolve, 300));
//       }
//     } catch (error) {
//       console.error("PDF Export Error:", error);
//     } finally {
//       setExportingPDF(false);
//       setloading(false);
//     }
//   };

//   const settingshowspecific3 = async (ID) => {
//     try {
//       let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
//       setfetchSpecficDemandDeductionDetail(res);
//       setSelectedDemandID(ID);
//       setShowSpecific(4);
//       let filtered = res;
//       console.log("filtered............", filtered);
//       filtered = filtered.filter((val) => val.DemandGenerationID == ID);
//       setselectedBillData(filtered[0]);
//       console.log("selected Bill ---> ", filtered[0]);
//     } catch (err) {
//       console.log(err);
//     }
//   };
//   const exportBillSlipPDF = async () => {
//     if (!billSlipRef.current) {
//       alert("Bill slip not found");
//       return;
//     }

//     setExportingBillSlipPDF(true);

//     try {
//       const canvas = await html2canvas(billSlipRef.current, {
//         scale: 2,
//         useCORS: true,
//         backgroundColor: "#ffffff",
//       });

//       const pdf = new jsPDF("p", "mm", "a4");
//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();
//       const margin = 5;
//       const maxImgWidth = pageWidth - margin * 2;
//       const maxImgHeight = pageHeight - margin * 2;
//       const widthRatio = maxImgWidth / canvas.width;
//       const heightRatio = maxImgHeight / canvas.height;
//       const ratio = Math.min(widthRatio, heightRatio);
//       const imgWidth = canvas.width * ratio;
//       const imgHeight = canvas.height * ratio;

//       pdf.addImage(
//         canvas.toDataURL("image/png"),
//         "PNG",
//         (pageWidth - imgWidth) / 2,
//         margin,
//         imgWidth,
//         imgHeight,
//       );

//       const transactionNo =
//         selectedBillData?.DemandGenerationID || selectedDemandID;
//       pdf.save(`Bill_Slip_${transactionNo || "RDD"}.pdf`);
//     } catch (error) {
//       console.error("Bill slip PDF export error:", error);
//       alert("Failed to export bill slip PDF. Please try again.");
//     } finally {
//       setExportingBillSlipPDF(false);
//     }
//   };

//   const BackFunction = () => {
//     setfetchSpecficDemandDeductionDetail([]);
//     setSelectedBills("");
//     setselectedBillData([]);
//     setShowSpecific(0);
//   };

//   const labelStyle = {
//     border: "1px solid #000",
//     padding: "6px",
//     width: "18%",
//     fontWeight: "bold",
//     background: "#f5f5f5",
//   };

//   const valueStyle = {
//     border: "1px solid #000",
//     padding: "6px",
//   };

//   const tableHead = {
//     border: "1px solid #000",
//     background: "#d9d9d9",
//     padding: "8px",
//     textAlign: "center",
//   };

//   const tableCell = {
//     border: "1px solid #000",
//     padding: "8px",
//     textAlign: "center",
//   };
//   const vendorData = fetchSpecificDemandDeductionDetail?.find(
//     (item) => item.TypeOfAmount === "Total Amount Payable",
//   );
//   const officerStyle = {
//     marginTop: "8px",
//     fontSize: "12px",
//     fontWeight: "bold",
//     textAlign: "center",
//   };

//   const officerMarathiStyle = {
//     fontSize: "11px",
//     textAlign: "center",
//     marginTop: "3px",
//   };
//   const footerTitleStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     marginTop: "8px",
//   };

//   const footerTitleTdStyle = {
//     border: "1px solid #555",
//     padding: "6px",
//     textAlign: "center",
//     fontSize: "12px",
//     fontWeight: "bold",
//   };

//   const remarksTableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//   };

//   const remarksTableTdStyle = {
//     border: "1px solid #555",
//     padding: "8px",
//     fontSize: "11px",
//     lineHeight: "18px",
//     textAlign: "right",
//   };

//   const instructionTableStyle = {
//     width: "100%",
//     borderCollapse: "collapse",
//     marginTop: "-1px",
//   };

//   const instructionTableTdStyle = {
//     border: "1px solid #555",
//     padding: "10px",
//     fontSize: "11px",
//     lineHeight: "18px",
//     textAlign: "justify",
//   };

//   const signatureTableStyle = {
//     width: "100%",
//     tableLayout: "fixed",
//     borderCollapse: "collapse",
//     marginTop: "-1px",
//   };

//   const signatureTableTdStyle = {
//     border: "1px solid #555",
//     height: "80px",
//     width: "50%",
//     verticalAlign: "bottom",
//     padding: "10px",
//   };

//   const signBoxStyle = {
//     width: "100%",
//     height: "100%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "flex-end",
//   };

//   const signSpaceStyle = {
//     height: "25px",
//   };

//   const signTitleStyle = {
//     fontSize: "12px",
//     fontWeight: "bold",
//     textAlign: "center",
//   };

//   return (
//     <>
//       {false && (
//         <div>
//           <div
//             style={{
//               overflowX: "hidden",
//               display: "grid",
//               justifyContent: "center",
//               padding: "20px 0px",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "80vw",
//                 maxWidth: "1200px",
//                 marginBottom: "15px",
//               }}
//             >
//               <h4 style={{ margin: "10px" }}>{t("Bill List")}</h4>
//               <input
//                 type="text"
//                 placeholder={t("Search")}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 value={searchTerm}
//                 style={{
//                   width: "250px",
//                   padding: "8px 12px",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   backgroundColor: "aliceblue",
//                   fontSize: "14px",
//                   marginRight: "10px",
//                 }}
//               />
//             </div>

//             <div
//               style={{
//                 display: "grid",
//                 justifyContent: "center",
//                 boxShadow: "0px 0px 3px",
//                 borderRadius: "20px",
//                 width: "78vw",
//               }}
//             >
//               <div
//                 style={{
//                   overflowX: "auto",
//                   width: "78vw",
//                   borderRadius: "20px",
//                 }}
//               >
//                 <table
//                   style={{
//                     backgroundColor: "white",
//                     width: "130%",
//                     borderRadius: "20px",
//                     overflow: "hidden",
//                     borderCollapse: "collapse",
//                   }}
//                 >
//                   <thead style={{ borderTop: "none" }}>
//                     <tr
//                       style={{
//                         background:
//                           "linear-gradient(to bottom, #CCEAF7, #CFE4F1, #CCE1EE, #D8D9EC)",
//                         color: "black",
//                         border: "none",
//                         borderRadius: "10px",
//                         overflow: "hidden",
//                         height: "3rem",
//                         fontSize: "12px",
//                         textAlign: "center",
//                       }}
//                     >
//                       <th style={{ width: "6%" }}>{t("Bill UID")}</th>
//                       <th style={{ width: "7%" }}>{t("HeadCode Name")}</th>
//                       <th style={{ width: "8%" }}>{t("Proposal UID")}</th>
//                       <th style={{ width: "7%" }}>{t("RA Bill Number")}</th>
//                       <th style={{ width: "6%" }}>{t("District")}</th>
//                       <th style={{ width: "10%" }}>{t("Vendor Name")}</th>
//                       <th style={{ width: "8%" }}>{t("Bill Amount")}</th>
//                       <th style={{ width: "8%" }}>{t("Deduction Amount")}</th>
//                       <th style={{ width: "8%" }}>{t("Payable Amount")}</th>
//                       <th style={{ width: "8%" }}>{t("Remark")}</th>
//                       <th style={{ width: "14%" }}>{t("Uploaded Files")}</th>
//                       <th style={{ width: "10%" }}>{t("Date")}</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentBills?.map((technicalInwards, index) => {
//                       const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                       return (
//                         <tr
//                           className="px-3"
//                           key={index}
//                           style={{
//                             borderBottom: "1px solid #3b409e",
//                             backgroundColor: bgColor,
//                           }}
//                         >
//                           <td className="py-2">
//                             {technicalInwards.DemandGenerationID}
//                           </td>
//                           <td className="py-2">{technicalInwards.BudgetID}</td>
//                           <td className="py-2">{technicalInwards.ProjectID}</td>
//                           <td className="py-2">
//                             {technicalInwards.RABillNumber}
//                           </td>
//                           <td className="py-2">{technicalInwards.District}</td>
//                           <td className="py-2">
//                             {technicalInwards.ContractorName}
//                           </td>
//                           <td className="py-2">
//                             {technicalInwards.BillAmount / 10000000} CR
//                           </td>
//                           <td className="py-2">
//                             {technicalInwards.DeductionAmount / 10000000} CR
//                           </td>
//                           <td className="py-2">
//                             {technicalInwards.NetPayableAmount / 10000000} CR
//                           </td>
//                           <td className="py-2">
//                             {technicalInwards.Remark ? (
//                               technicalInwards.Remark
//                             ) : (
//                               <p className="text-danger fw-bold my-auto">
//                                 {t("No Remark")}
//                               </p>
//                             )}
//                           </td>
//                           <td style={{ padding: "8px" }}>
//                             {technicalInwards.UploadBillCopy ? (
//                               <a
//                                 href={`${apiurl}/BillCopyDocsImages/${technicalInwards.UploadBillCopy}`}
//                                 target="_blank"
//                                 rel="noreferrer"
//                               >
//                                 {technicalInwards.UploadBillCopy}
//                               </a>
//                             ) : (
//                               <p className="text-danger my-auto fw-bold">
//                                 {t("No File")}
//                               </p>
//                             )}
//                           </td>
//                           <td className="py-2">
//                             {new Date(technicalInwards.Date).toLocaleString()}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//               }}
//             >
//               <div
//                 className="ms-auto"
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-evenly",
//                   margin: "10px 0",
//                 }}
//               >
//                 <button
//                   onClick={() =>
//                     setCurrentPage((prev) => Math.max(prev - 1, 1))
//                   }
//                   disabled={currentPage === 1}
//                   style={{
//                     padding: "8px 15px",
//                     borderRadius: "5px",
//                     cursor: "pointer",
//                     backgroundColor: currentPage === 1 ? "#ccc" : "blue",
//                     color: "white",
//                   }}
//                 >
//                   {t("Previous")}
//                 </button>
//                 <span style={{ fontSize: "18px", fontWeight: "bold" }}>
//                   {t("Page")} {currentPage} {t("of")} {totalPages}
//                 </span>
//                 <button
//                   onClick={() =>
//                     setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                   }
//                   disabled={currentPage === totalPages}
//                   style={{
//                     padding: "6px 15px",
//                     borderRadius: "5px",
//                     cursor: "pointer",
//                     backgroundColor:
//                       currentPage === totalPages ? "#ccc" : "blue",
//                     color: "white",
//                   }}
//                 >
//                   {t("Next")}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {false && (
//         <div
//           className="col-12"
//           style={{
//             display: "grid",
//             justifyContent: "center",
//             maxWidth: "100%",
//           }}
//         >
//           <div
//             className="col-12 mb-3"
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//             }}
//           >
//             <h4 className="my-auto">{t("Bill Outwards")}</h4>
//             <input
//               type="text"
//               placeholder={t("Search Here")}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               value={searchTerm}
//               style={{
//                 width: "250px",
//                 padding: "8px 12px",
//                 border: "1px solid #ccc",
//                 borderRadius: "5px",
//                 backgroundColor: "aliceblue",
//                 fontSize: "14px",
//                 marginRight: "10px",
//               }}
//             />
//           </div>
//           <div
//             className="col-12"
//             style={{
//               background:
//                 "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
//               display: "flex",
//               overflowX: "auto",
//               border: "1px solid #3b409e",
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 minWidth: "1200px",
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{ color: "white", border: "none", height: "3.5rem" }}
//                 >
//                   <th
//                     style={{ minWidth: "150px", padding: "8px" }}
//                     rowSpan={2}
//                     colSpan={1}
//                   >
//                     {t("Bill Number")}
//                   </th>
//                   <th
//                     style={{ width: "80%", border: "1px solid white" }}
//                     colSpan={9}
//                   >
//                     {t("Approved by")}
//                   </th>{" "}
//                   {/* changed from 9 to 8 */}
//                   <th
//                     style={{
//                       width: "10%",
//                       textAlign: "center",
//                       border: "1px solid white",
//                     }}
//                     colSpan={1}
//                     rowSpan={2}
//                   >
//                     {t("Details")}
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {currentBills?.length === 0 ? (
//                   <tr>
//                     <td
//                       colSpan="10"
//                       style={{
//                         textAlign: "center",
//                         padding: "20px",
//                         backgroundColor: "#f9f9f9",
//                       }}
//                     >
//                       {t("No data available")}
//                     </td>
//                   </tr>
//                 ) : (
//                   currentBills?.map((proposal, index) => {
//                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                     return (
//                       <tr
//                         style={{
//                           borderBottom: "1px solid #3b409e",
//                           backgroundColor: bgColor,
//                         }}
//                         key={proposal.DemandGenerationID || index}
//                       >
//                         <td style={{ padding: "8px" }}>
//                           {proposal.RABillNumber}
//                         </td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             textAlign: "center",
//                             borderRight: "1px solid #3b409e",
//                           }}
//                         >
//                           {proposal.Approvance1 === "true"
//                             ? "✅"
//                             : proposal.Approvance1 === "false"
//                               ? "❌"
//                               : "-"}
//                         </td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             textAlign: "center",
//                             borderRight: "1px solid #3b409e",
//                           }}
//                         >
//                           {proposal.Approvance2 === "true"
//                             ? "✅"
//                             : proposal.Approvance2 === "false"
//                               ? "❌"
//                               : "-"}
//                         </td>
//                         <td style={cellStyle}>
//                           {proposal.Approvance3 === "true"
//                             ? "✅"
//                             : proposal.Approvance3 === "false"
//                               ? "❌"
//                               : "-"}
//                         </td>
//                         <td style={cellStyle}>
//                           {proposal.Approvance4 === "true"
//                             ? "✅"
//                             : proposal.Approvance4 === "false"
//                               ? "❌"
//                               : "-"}
//                         </td>
//                         <td style={cellStyle}>
//                           {proposal.Approvance5 === "true"
//                             ? "✅"
//                             : proposal.Approvance5 === "false"
//                               ? "❌"
//                               : "-"}
//                         </td>
//                         <td style={cellStyle}>
//                           {proposal.Approvance6 === "true"
//                             ? "✅"
//                             : proposal.Approvance6 === "false"
//                               ? "❌"
//                               : "-"}
//                         </td>
//                         <td style={cellStyle}>
//                           {proposal.Approvance7 === "true"
//                             ? "✅"
//                             : proposal.Approvance7 === "false"
//                               ? "❌"
//                               : "-"}
//                         </td>
//                         <td style={cellStyle}>
//                           {proposal.Approvance8 === "true"
//                             ? "✅"
//                             : proposal.Approvance8 === "false"
//                               ? "❌"
//                               : "-"}
//                         </td>
//                         <td style={cellStyle}>
//                           {proposal.Approvance9 === "true"
//                             ? "✅"
//                             : proposal.Approvance9 === "false"
//                               ? "❌"
//                               : "-"}
//                         </td>
//                         {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
//                         <td>
//                           <button
//                             onClick={() =>
//                               selectedBillDetails(proposal.DemandGenerationID)
//                             }
//                             style={{
//                               cursor: "pointer",
//                               backgroundColor: "#0098d5",
//                               color: "white",
//                               border: "none",
//                               padding: "5px 10px",
//                               borderRadius: "4px",
//                             }}
//                           >
//                             {t("View")}
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 )}
//               </tbody>
//             </table>
//           </div>

//           <div
//             className="col-12"
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               height: "3rem",
//               alignItems: "center",
//             }}
//           >
//             <div>
//               <p>
//                 {t("Showing")} {currentBills?.length || 0} {t("of")}{" "}
//                 {proposallist?.length || 0} {t("entries")}
//               </p>
//             </div>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <button
//                 onClick={() => setCurrentPage(1)}
//                 disabled={currentPage === 1}
//                 style={{
//                   backgroundColor: "white",
//                   color: "black",
//                   border: "1px solid lightgrey",
//                   cursor: "pointer",
//                   fontSize: "24px",
//                 }}
//               >
//                 &laquo;
//               </button>
//               <button
//                 onClick={() => setCurrentPage(currentPage - 1)}
//                 disabled={currentPage === 1}
//                 style={{
//                   backgroundColor: "white",
//                   color: "black",
//                   border: "1px solid lightgrey",
//                   cursor: "pointer",
//                   fontSize: "24px",
//                   borderLeft: "none",
//                 }}
//               >
//                 &lt;
//               </button>
//               <button
//                 style={{
//                   background:
//                     "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
//                   color: "white",
//                   cursor: "pointer",
//                   fontSize: "24px",
//                   width: "3rem",
//                   border: "1px solid lightgrey",
//                   borderLeft: "none",
//                 }}
//               >
//                 {currentPage}
//               </button>
//               <button
//                 onClick={() => setCurrentPage(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   backgroundColor: "white",
//                   color: "black",
//                   border: "1px solid lightgrey",
//                   cursor: "pointer",
//                   fontSize: "24px",
//                   borderLeft: "none",
//                 }}
//               >
//                 &gt;
//               </button>
//               <button
//                 onClick={() => setCurrentPage(totalPages)}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   backgroundColor: "white",
//                   color: "black",
//                   border: "1px solid lightgrey",
//                   cursor: "pointer",
//                   fontSize: "24px",
//                   borderLeft: "none",
//                 }}
//               >
//                 &raquo;
//               </button>
//             </div>
//           </div>

//           {selectedProposal && (
//             <div
//               onClick={() => setSelectedProposal(null)}
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100vw",
//                 height: "100vh",
//                 backgroundColor: "rgba(0,0,0,0.5)",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 zIndex: 9999,
//               }}
//             >
//               <div
//                 onClick={(e) => e.stopPropagation()}
//                 style={{
//                   backgroundColor: "white",
//                   padding: "20px",
//                   borderRadius: "8px",
//                   maxWidth: "600px",
//                   width: "90%",
//                   maxHeight: "80vh",
//                   overflowY: "auto",
//                   boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
//                   position: "relative",
//                 }}
//               >
//                 <h3>{t("Bill Details")}</h3>
//                 <button
//                   onClick={() => setSelectedProposal(null)}
//                   style={{
//                     position: "absolute",
//                     top: "10px",
//                     right: "10px",
//                     background: "transparent",
//                     border: "none",
//                     fontSize: "20px",
//                     cursor: "pointer",
//                   }}
//                 >
//                   &times;
//                 </button>
//                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                   <tbody>
//                     {Object.entries(selectedProposal).map(([key, value]) => (
//                       <tr key={key} style={{ borderBottom: "1px solid #ddd" }}>
//                         <td
//                           style={{
//                             fontWeight: "bold",
//                             padding: "8px",
//                             width: "40%",
//                             backgroundColor: "#f0f0f0",
//                           }}
//                         >
//                           {key}
//                         </td>
//                         <td style={{ padding: "8px" }}>
//                           {key == "Bill Number" && value ? value : "--"}
//                           {/* Handle Upload Bill Copy link */}
//                           {key === "Upload Bill Copy" && value ? (
//                             <a
//                               href={`${apiurl}/BillCopyDocsImages/${value}`}
//                               target="_blank"
//                               rel="noreferrer"
//                             >
//                               {value}
//                             </a>
//                           ) : value === null || value === "" ? (
//                             "-"
//                           ) : (
//                             value.toString()
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       <div
//         className="col-12"
//         style={{
//           backgroundColor: "#EFF3F8",
//           height: "89vh",
//           overflowX: "hidden",
//           overflowY: "scroll",
//           position: "relative",
//         }}
//       >
//         {showspecific === 0 && (
//           <div
//             style={{
//               filter: loading ? "blur(4px)" : "none",
//               pointerEvents: loading ? "none" : "auto",
//               transition: "0.2s ease",
//             }}
//           >
//             <div className="col-11 m-auto">
//               <div className="col-12 ">
//                 <div
//                   className="col-12 px-4 mb-4 mt-3"
//                   style={{
//                     filter: loading ? "blur(4px)" : "none",
//                     pointerEvents: loading ? "none" : "auto",
//                     transition: "0.2s ease",
//                   }}
//                 >
//                   {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
//                   <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
//                     <h5 className="fw-bold d-flex align-items-center m-0">
//                       <img
//                         src="/GR-Approval64.png"
//                         alt="Technical Approval"
//                         style={{
//                           width: "24px",
//                           height: "24px",
//                           marginRight: "6px",
//                         }}
//                       />
//                       Fund Release From BDS
//                     </h5>

//                     <div className="d-flex gap-2">
//                       <button
//                         className="btn btn-success"
//                         onClick={() =>
//                           exportTableByClassToExcel(
//                             filteredBills,
//                             "Bills_Outward.xlsx",
//                           )
//                         }
//                       >
//                         {t("Download Excel")}
//                       </button>

//                       <button
//                         className="btn btn-danger"
//                         onClick={() =>
//                           downloadTableOnlyAsPDF(
//                             "BillsOutwardTable",
//                             "Bills_Outward.pdf",
//                             "Bills Outward Report",
//                           )
//                         }
//                       >
//                         {t("Download PDF")}
//                       </button>
//                     </div>
//                   </div>

//                   {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "8px",
//                       flexWrap: "nowrap",
//                     }}
//                   >
//                     {UserRole === "State" && RoleID == 29 && (
//                       <select
//                         value={typeofData}
//                         onChange={(e) => settypeofData(e.target.value)}
//                         style={{
//                           width: "150px",
//                           padding: "8px",
//                           border: "1px solid #ccc",
//                           borderRadius: "8px",
//                           fontSize: "13px",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }}
//                       >
//                         <option value="" disabled selected>
//                           Choose Data
//                         </option>
//                         <option value="District">
//                           {t(
//                             "3054-2419(Roads and bridge repair maintenance program)",
//                           )}
//                         </option>
//                         <option value="State">
//                           {t("2515-1238(MLA Representative)")}
//                         </option>
//                       </select>
//                     )}
//                     {/* Status */}
//                     <select
//                       value={statusofData1}
//                       onChange={(e) => setstatusofData1(e.target.value)}
//                       style={{
//                         width: "150px",
//                         padding: "8px",
//                         border: "1px solid #ccc",
//                         borderRadius: "8px",
//                         fontSize: "13px",
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                     >
//                       <option value="">{t("All")}</option>
//                       <option value="Approved">{t("Approved")}</option>
//                       <option value="false">{t("Pending")}</option>
//                       <option value="Rejected">{t("Rejected")}</option>
//                     </select>

//                     {/* District */}
//                     {UserRole === "State" && (
//                       <div style={{ position: "relative", width: "160px" }}>
//                         {/* Dropdown trigger */}
//                         <div
//                           onClick={() => setOpenDistrict(!openDistrict)}
//                           style={{
//                             padding: "8px",
//                             border: "1px solid #ccc",
//                             borderRadius: "8px",
//                             background: "#fff",
//                             cursor: "pointer",
//                             fontSize: "13px",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                           }}
//                         >
//                           {SelectedDistrict.length > 0
//                             ? SelectedDistrict.join(", ")
//                             : "Select District"}
//                         </div>

//                         {/* Dropdown list */}
//                         {openDistrict && (
//                           <div
//                             style={{
//                               position: "absolute",
//                               top: "100%",
//                               left: 0,
//                               width: "100%",
//                               background: "#fff",
//                               border: "1px solid #ccc",
//                               borderRadius: "8px",
//                               marginTop: "4px",
//                               zIndex: 1000,
//                             }}
//                           >
//                             <label
//                               style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 padding: "6px 8px",
//                                 borderBottom: "1px solid #eee",
//                                 cursor: "pointer",
//                                 fontSize: "13px",
//                                 whiteSpace: "nowrap",
//                                 overflow: "hidden",
//                                 textOverflow: "ellipsis",
//                               }}
//                             >
//                               <input
//                                 type="checkbox"
//                                 checked={isAllSelected}
//                                 onChange={toggleAllDistricts}
//                                 style={{ marginRight: "6px" }}
//                               />
//                               {t("All Districts")}
//                             </label>
//                             <div
//                               style={{ maxHeight: "150px", overflowY: "auto" }}
//                             >
//                               {[
//                                 ...new Set(
//                                   AllDistrict?.map((d) => d.District_Marathi),
//                                 ),
//                               ].map((district, index) => (
//                                 <label
//                                   key={index}
//                                   style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     padding: "6px 8px",
//                                     cursor: "pointer",
//                                     fontSize: "13px",
//                                     whiteSpace: "nowrap",
//                                     overflow: "hidden",
//                                     textOverflow: "ellipsis",
//                                   }}
//                                 >
//                                   <input
//                                     type="checkbox"
//                                     checked={SelectedDistrict.includes(
//                                       district,
//                                     )}
//                                     onChange={() =>
//                                       handleDistrictToggle(district)
//                                     }
//                                     onClick={(e) => e.stopPropagation()}
//                                     style={{ marginRight: "6px" }}
//                                   />
//                                   {district}
//                                 </label>
//                               ))}
//                             </div>

//                             {/* Footer */}
//                             <div
//                               style={{
//                                 padding: "6px",
//                                 textAlign: "right",
//                                 borderTop: "1px solid #eee",
//                               }}
//                             >
//                               <button
//                                 onClick={() => setOpenDistrict(false)}
//                                 style={{
//                                   padding: "4px 10px",
//                                   fontSize: "12px",
//                                   border: "none",
//                                   borderRadius: "6px",
//                                   background: "#0d6efd",
//                                   color: "#fff",
//                                   cursor: "pointer",
//                                 }}
//                               >
//                                 OK
//                               </button>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     )}

//                     {/* Search */}
//                     <div style={{ position: "relative", width: "220px" }}>
//                       <img
//                         src="/Search32.png"
//                         alt="Search"
//                         style={{
//                           position: "absolute",
//                           top: "50%",
//                           left: "10px",
//                           transform: "translateY(-50%)",
//                           width: "16px",
//                           opacity: 0.6,
//                         }}
//                       />
//                       <input
//                         type="text"
//                         placeholder={t("Search Here")}
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         style={{
//                           width: "100%",
//                           padding: "8px 12px 8px 32px",
//                           border: "1px solid #ccc",
//                           borderRadius: "8px",
//                           backgroundColor: "#f1f6fc",
//                           fontSize: "13px",
//                           whiteSpace: "nowrap",
//                           overflow: "hidden",
//                           textOverflow: "ellipsis",
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-12 pb-5">
//                   <div
//                     className="m-auto mb-3"
//                     style={{
//                       backgroundColor: "white",
//                       padding: "40px 40px",
//                       boxShadow: "0px 0px 5px 1px #E4E8EC",
//                       borderRadius: "20px",
//                       width: "100%",
//                       maxWidth: "100%",
//                       overflowX: "hidden",
//                     }}
//                   >
//                     <div
//                       className="col-12 tableDesign"
//                       style={{ background: "#2C78DB",  overflowX: "auto",
//                       overflowY: "auto",
//                       maxHeight: "600px", // change height as needed
//                       position: "relative", }}
//                     >
//                       <table
//                         className="m-0 p-0 BillsOutwardTable"
//                         style={{ width: "100%", borderCollapse: "collapse" }}
//                       >
//                         <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
//                       top: 0,
//                       zIndex: 10,}}>
//                           <tr
//                             style={{
//                               color: "white",
//                               border: "none",
//                               height: "3rem",
//                               fontSize: "18px",
//                             }}
//                           >
//                             <th
//                               style={{ minWidth: "70px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Sr.No.")}
//                             </th>
//                             <th
//                               style={{ minWidth: "130px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Bill ID")}
//                             </th>
//                             <th
//                               style={{ minWidth: "130px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Bill Number")}
//                             </th>
//                             {UserRole === "State" && RoleID != 29 ? (
//                               ""
//                             ) : (
//                               <th
//                                 style={{ minWidth: "250px", padding: "8px" }}
//                                 rowSpan={2}
//                                 colSpan={1}
//                               >
//                                 {t("Head ID")}
//                               </th>
//                             )}
//                             <th
//                               style={{ minWidth: "250px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Work Name")}
//                             </th>
//                             <th
//                               style={{ minWidth: "250px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Job ID")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Technical Sanction Number")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Physical Progress(in %)")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("District")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Vendor Name")}
//                             </th>
//                             {/* <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Work Order UID")}</th> */}
//                             <th
//                               style={{ minWidth: "250px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Bill Copy")}
//                             </th>
//                             <th
//                               style={{ minWidth: "250px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Demand Copy")}
//                             </th>
//                             <th
//                               style={{ minWidth: "250px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Fund release order")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Remark")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Bill Amount")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Net Payable Amount")}
//                             </th>
//                             <th
//                               style={{ minWidth: "150px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Deduction Amount")}
//                             </th>
//                             <th
//                               style={{ minWidth: "190px", padding: "8px" }}
//                               rowSpan={2}
//                               colSpan={1}
//                             >
//                               {t("Date")}
//                             </th>
//                             <th style={{ padding: "8px" }} colSpan={7}>
//                               {t("Status")}
//                             </th>{" "}
//                             {/* changed from 9 to 7 */}
//                             {/* <th style={headerStyle} colSpan={1} rowSpan={2}>Details</th> */}
//                           </tr>
//                         </thead>

//                         <tbody>
//                           <>
//                             {displayedGRS?.length === 0 ? (
//                               <tr>
//                                 <td
//                                   colSpan="30"
//                                   style={{
//                                     textAlign: "center",
//                                     padding: "20px",
//                                     backgroundColor: "#f9f9f9",
//                                   }}
//                                 >
//                                   {t("No data available")}
//                                 </td>
//                               </tr>
//                             ) : (
//                               displayedGRS?.map((proposal, index) => {
//                                 const bgColor =
//                                   index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                 return (
//                                   <tr
//                                     style={{ backgroundColor: bgColor,fontSize:"18px" }}
//                                     key={index}
//                                   >
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {indexOfFirstBill + index + 1}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.DemandGenerationID}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.RABillNumber}
//                                     </td>
//                                     {UserRole === "State" && RoleID != 29 ? (
//                                       ""
//                                     ) : (
//                                       <td style={{ padding: "8px 8px" }}>
//                                         {proposal.BudgetID}
//                                       </td>
//                                     )}
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.ProjectID}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.JOB_ID}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.BillNumber}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.physicalValueOfProgress}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.District}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.ContractorName}
//                                     </td>
//                                     {/* <td style={{ padding: '8px 8px' }}>{proposal.WorkOrderUID}</td> */}
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.UploadBillCopy ? (
//                                         <a
//                                           href={`${apiurl}/BillCopyDocsImages/${proposal.UploadBillCopy}`}
//                                           target="_blank"
//                                         >
//                                           {proposal.UploadBillCopy}
//                                         </a>
//                                       ) : (
//                                         <p className="fw-bold text-danger my-auto">
//                                           {t("No File")}
//                                         </p>
//                                       )}
//                                     </td>
//                                     {/* <td style={{ padding: "8px 8px" }}>
//                                     {proposal.BillCopy ? (
//                                       <a
//                                         href={`${apiurl}/BillCopyDocsImages/${proposal.BillCopy}`}
//                                         target="_blank"
//                                       >
//                                         {proposal.BillCopy}
//                                       </a>
//                                     ) : (
//                                       <p className="fw-bold text-danger my-auto">
//                                         {t("No File")}
//                                       </p>
//                                     )}
//                                   </td> */}
//                                     <td
//                                       style={{
//                                         fontSize: "12px",
//                                         padding: "5px",
//                                       }}
//                                     >
//                                       <button
//                                         className="btn py-1 d-flex align-items-center justify-content-center gap-2 mx-auto"
//                                         style={{
//                                           minHeight: "33px",
//                                           minWidth: "100px",
//                                           padding: "0.375rem 0.75rem",
//                                           fontSize: "0.9rem",
//                                           fontWeight: 400,
//                                           lineHeight: 1.5,
//                                           cursor: "pointer",
//                                           background:
//                                             "linear-gradient(to right, #38439f, #048ecc)",
//                                           color: "white",
//                                           borderRadius: "999px",
//                                           border: "1px solid transparent",
//                                         }}
//                                         onClick={() =>
//                                           settingshowspecific3(
//                                             proposal.DemandGenerationID,
//                                           )
//                                         }
//                                       >
//                                         <img
//                                           src="/view32.png"
//                                           alt="view"
//                                           width="15"
//                                           height="15"
//                                           style={{ verticalAlign: "middle" }}
//                                         />
//                                         <span style={{ lineHeight: 1 }}>
//                                           View{" "}
//                                         </span>
//                                       </button>
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.UploadWork ? (
//                                         <a
//                                           href={`${apiurl}/UploadWorkFiles/${proposal.UploadWork}`}
//                                           target="_blank"
//                                         >
//                                           {proposal.UploadWork}
//                                         </a>
//                                       ) : (
//                                         <p className="fw-bold text-danger my-auto">
//                                           {t("No File")}
//                                         </p>
//                                       )}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.Remark}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.BillAmount}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.NetPayableAmount}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.DeductionAmount}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {new Date(proposal.Date).toLocaleString()}
//                                     </td>
//                                     <td style={{ padding: "8px 8px" }}>
//                                       {proposal.Status}
//                                     </td>
//                                   </tr>
//                                 );
//                               })
//                             )}
//                              <tr
//                               style={{
//                                 fontWeight: "600",
//                                 backgroundColor: "#f0f0f0",
//                                 fontSize: "18px",
//                                 textAlign:"center"
//                               }}
//                             >
//                               <td
//                                 colSpan={14}
//                                 style={{ textAlign: "right", padding: "8px" }}
//                               >
//                                 {t("Page Total")}
//                               </td>

//                               <td style={{ padding: "8px" }}>
//                                 ₹ {pagetotalBillamt.toLocaleString("en-IN")}
//                               </td>
//                               <td style={{ padding: "8px" }}>
//                                 ₹ {pagetotalpayableamt.toLocaleString("en-IN")}
//                               </td>
//                               <td style={{ padding: "8px" }}>
//                                 ₹ {pagetotaldeductionamt.toLocaleString("en-IN")}
//                               </td>
//                               {/* remaining columns */}
//                               <td colSpan={UserRole == "State" ? 19 : 20}></td>
//                             </tr>
//                             <tr
//                               style={{
//                                 fontWeight: "600",
//                                 backgroundColor: "#f0f0f0",
//                                 fontSize: "18px",
//                                 textAlign:"center"
//                               }}
//                             >
//                               <td
//                                 colSpan={14}
//                                 style={{ textAlign: "right", padding: "8px" }}
//                               >
//                                 {t(" Gross Total")}
//                               </td>

//                               <td style={{ padding: "8px" }}>
//                                 ₹ {totalBillamt.toLocaleString("en-IN")}
//                               </td>
//                               <td style={{ padding: "8px" }}>
//                                 ₹ {totalpayableamt.toLocaleString("en-IN")}
//                               </td>
//                               <td style={{ padding: "8px" }}>
//                                 ₹ {totaldeductionamt.toLocaleString("en-IN")}
//                               </td>
//                               {/* remaining columns */}
//                               <td colSpan={UserRole == "State" ? 19 : 20}></td>
//                             </tr>
//                           </>
//                         </tbody>
//                       </table>
//                     </div>
//                     {/* <div className="col-12 mt-4 mb-2">
//                     <div className="row">
//                       <div className="col-6">
//                         <p
//                           className="text-gray-600"
//                           style={{ fontSize: "14px" }}
//                         >
//                           {proposallist.length > 0
//                             ? `Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, filteredBills.length)} of ${filteredBills.length} entries`
//                             : "Showing 0 to 0 of 0 entries"}
//                         </p>
//                       </div>
//                       <div
//                         className="col-6"
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "end",
//                         }}
//                       >
//                         <button
//                           onClick={() => setCurrentPage(1)}
//                           disabled={currentPage === 1}
//                           style={{
//                             backgroundColor: "white",
//                             color: "black",
//                             border: "1px solid lightgrey",
//                             cursor: "pointer",
//                             fontSize: "20px",
//                             width: "2rem",
//                           }}
//                         >
//                           &laquo;
//                         </button>
//                         <button
//                           onClick={() => setCurrentPage(currentPage - 1)}
//                           disabled={currentPage === 1}
//                           style={{
//                             backgroundColor: "white",
//                             color: "black",
//                             border: "1px solid lightgrey",
//                             cursor: "pointer",
//                             fontSize: "20px",
//                             borderLeft: "none",
//                             width: "2rem",
//                           }}
//                         >
//                           &lt;
//                         </button>
//                         <button
//                           style={{
//                             background:
//                               "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
//                             color: "white",
//                             cursor: "pointer",
//                             fontSize: "20px",
//                             width: "2.4rem",
//                             border: "1px solid lightgrey",
//                             borderLeft: "none",
//                           }}
//                         >
//                           {currentPage}
//                         </button>
//                         <button
//                           onClick={() => setCurrentPage(currentPage + 1)}
//                           disabled={currentPage === totalPages}
//                           style={{
//                             backgroundColor: "white",
//                             color: "black",
//                             border: "1px solid lightgrey",
//                             cursor: "pointer",
//                             fontSize: "20px",
//                             borderLeft: "none",
//                             width: "2rem",
//                           }}
//                         >
//                           &gt;
//                         </button>
//                         <button
//                           onClick={() => setCurrentPage(totalPages)}
//                           disabled={currentPage === totalPages}
//                           style={{
//                             backgroundColor: "white",
//                             color: "black",
//                             border: "1px solid lightgrey",
//                             cursor: "pointer",
//                             fontSize: "20px",
//                             borderLeft: "none",
//                             width: "2rem",
//                           }}
//                         >
//                           &raquo;
//                         </button>
//                       </div>
//                     </div>
//                   </div> */}

//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         height: "4rem",
//                         alignItems: "center",
//                       }}
//                       className="mt-3"
//                     >
//                       <div>
//                         <p
//                           className="text-gray-600"
//                           style={{ fontSize: "18px" }}
//                         >
//                           {proposallist.length > 0
//                             ? `Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, filteredBills.length)} of ${filteredBills.length} entries`
//                             : "Showing 0 to 0 of 0 entries"}
//                         </p>
//                       </div>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "10px",
//                         }}
//                       >
//                         <GooglePagination
//                           currentPage={currentPage}
//                           totalPages={totalPages}
//                           onPageChange={setCurrentPage}
//                         />

//                         <button
//                           onClick={() => {
//                             setShowAll(!showAll);
//                             setCurrentPage(1);
//                           }}
//                           style={{
//                             border: "none",
//                             outline: "none",
//                             cursor: "pointer",
//                             padding: "8px 16px",
//                             borderRadius: "20px",
//                             fontSize: "13px",
//                             fontWeight: "600",
//                             color: "#fff",
//                             background: showAll
//                               ? "linear-gradient(135deg, #28a745, #20c997)"
//                               : "linear-gradient(135deg, #0067ab, #0098d5)",
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                             transition: "all 0.3s ease",
//                           }}
//                         >
//                           {showAll ? "✓ Showing All" : "View All"}
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {selectedProposal && (
//               <div
//                 onClick={() => setSelectedProposal(null)}
//                 style={{
//                   position: "fixed",
//                   top: 0,
//                   left: 0,
//                   width: "100vw",
//                   height: "100vh",
//                   backgroundColor: "rgba(0, 0, 0, 0.84)",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   zIndex: 9999,
//                 }}
//               >
//                 <div
//                   onClick={(e) => e.stopPropagation()}
//                   style={{
//                     backgroundColor: "white",
//                     padding: "40px 40px",
//                     borderRadius: "20px",
//                     width: "50%",
//                     maxHeight: "90vh",
//                     overflow: "hidden",
//                     boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
//                     position: "relative",
//                   }}
//                 >
//                   <div className="col-12">
//                     <div className="col-12  mb-3">
//                       <div className="row">
//                         <div className="col-6">
//                           <h5 className="fw-bold">{t("Bill Details")}</h5>
//                         </div>

//                         <div
//                           className="col-6"
//                           style={{
//                             display: "flex",
//                             justifyContent: "flex-end",
//                           }}
//                         >
//                           <button
//                             onClick={() => setSelectedProposal(null)}
//                             style={{
//                               width: "32px",
//                               height: "32px",
//                               borderRadius: "50%",
//                               backgroundColor: "red",
//                               border: "none",
//                               display: "flex",
//                               justifyContent: "center",
//                               alignItems: "center",
//                               cursor: "pointer",
//                               fontSize: "24px",
//                               fontWeight: "bold",
//                               color: "white",
//                               lineHeight: 1,
//                             }}
//                           >
//                             ×
//                           </button>
//                         </div>
//                       </div>
//                     </div>

//                     <div
//                       className="col-12"
//                       style={{
//                         height: "59vh",
//                         overflowX: "hidden",
//                         overflowY: "scroll",
//                         scrollBehavior: "smooth",
//                       }}
//                     >
//                       <table
//                         style={{
//                           width: "100%",
//                           height: "100%",
//                           borderCollapse: "collapse",
//                         }}
//                       >
//                         <tbody>
//                           {Object.entries(selectedProposal).map(
//                             ([key, value], index) => (
//                               <>
//                                 <tr
//                                   key={key}
//                                   style={{
//                                     backgroundColor:
//                                       index % 2 === 0 ? "#2B75D5" : "#cce0f9",
//                                     border: "1px solid #cce0f9",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       fontWeight: "bold",
//                                       padding: "8px",
//                                       width: "40%",
//                                       backgroundColor: "#2B75D5",
//                                       color: "white",
//                                       border: "1px solid #cce0f9",
//                                     }}
//                                   >
//                                     {key}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "8px",
//                                       color: "black",
//                                       backgroundColor:
//                                         index % 2 === 0 ? "#E3EBF5" : "#D0DEF1",
//                                     }}
//                                   >
//                                     {/* Handle Upload Bill Copy link */}
//                                     {key === "Upload Bill Copy" && value ? (
//                                       <a
//                                         href={`${apiurl}/BillCopyDocsImages/${value}`}
//                                         target="_blank"
//                                         rel="noreferrer"
//                                       >
//                                         {value}
//                                       </a>
//                                     ) : value === null || value === "" ? (
//                                       "-"
//                                     ) : (
//                                       value.toString()
//                                     )}
//                                   </td>
//                                 </tr>
//                               </>
//                             ),
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         {showspecific === 4 && (
//         <>
//           <div className="col-12 m-auto" >
//             <div className="col-12 m-auto my-15 mb-10 budgetContainer " style={{
//         maxHeight: "85vh",   // or 700px
//         overflowY: "auto",
//         overflowX: "hidden",
//         border: "1px solid #ddd",
//         borderRadius: "8px",
//       }}>
//               <div className="m-auto budgetElement"    >
//                 {/* Heading */}

//                 {/* TABLE CONTAINER */}
//                 <div
//                   className="mt-3 d-flex justify-content-between"
//                   style={{
//                     position: "relative",
//                     alignItems: "center",
//                     background: "#fff",
//                   }}
              
//                 >
//                   {/* TITLE – LEFT */}
//                   <div className="d-flex align-items-center gap-2 mb-3">
//                     <img
//                       src="/Bill-files64.png"
//                       alt="MAS Slip"
//                       width="26"
//                       height="26"
//                       // style={{ transform: "translateY(9px)", }}
//                     />
//                     <h5 className="m-0 fw-bold">Bill Slip</h5>
//                   </div>
//                   {/* BACK BUTTON – TOP RIGHT */}
//                   <div className="col-4 pb-3 d-flex justify-content-end gap-2">
//                     <button
//                       className="btn btn-primary d-flex align-items-center gap-2"
//                       style={{
//                         borderRadius: "999px",
//                         padding: "6px 22px",
//                         fontSize: "14px",
//                         zIndex: 10,
//                       }}
//                       onClick={exportBillSlipPDF}
//                       disabled={exportingBillSlipPDF}
//                     >
//                       {exportingBillSlipPDF ? "Exporting..." : "Export PDF"}
//                     </button>
//                     <button
//                       className="btn btn-danger d-flex align-items-center gap-2"
//                       style={{
//                         top: "12px",
//                         right: "12px",
//                         borderRadius: "999px",
//                         padding: "6px 22px",
//                         fontSize: "14px",
//                         zIndex: 10,
//                       }}
//                       onClick={BackFunction}
//                     >
//                       {/* <img
//                         src={Back32}
//                         alt="back"
//                         width="14"
//                         height="14"
//                         // style={{ filter: "brightness(0) invert(1)" }}
//                       /> */}
//                       Back
//                     </button>
//                   </div>
//                 </div>

//                 {/* ================= HEADER ================= */}
//                 <div  ref={billSlipRef}> 
//                 <div
//                   className="text-center text-white py-3"
//                   style={{
//                     background: "linear-gradient(90deg, #2b4ea1, #0aa2d6)",
//                   }}
                  
//                 >
//                   <div style={{ fontSize: "18px", fontWeight: "bold" }}>
//                     Zila Parishad - {selectedBillData.District}
//                   </div>

//                   {/* <div style={{ fontSize: "15px", fontWeight: "bold" }}>
//                     प्रशासकीय मंजुरी वर्ष - 2026-2027
//                   </div>

//                   <div>विभाग - EXE.ENGINEER ZP Division {selectedBillData.Division}</div>

//                   <div>उप-विभाग - {selectedBillData.District}</div>

//                   <div class="small">
//                     या तपशीलवार शीर्षाचे देयकासाठी आवश्यक असेल तिथे वित्त
//                     विभागाचा अनौपचारिक संदर्भ तपासावा.
//                   </div> */}
//                 </div>
//                     <div className="border border-dark p-1">
//                     <table
//                       className="table mb-0"
//                       style={{ fontSize: "14px", border: "none" }}
//                     >
//                       <tbody>
//                         {/* <tr>
//                           <td className='text-start'>
//                             <span>UserName :</span>

//                           </td>
//                           <td className='text-end'>
//                             <span>DateTime : </span>
//                           </td>
//                         </tr> */}
//                         <tr>
//                           <td
//                             colSpan={2}
//                             className="fw-bold text-center fs-6 p-1"
//                           >
//                             {" "}
//                             Bill Slip for RDD
//                           </td>
//                         </tr>
//                         {[
//                           [
//                             "User Name",
//                             `${selectedBillData.UploadedBy??"-"}`,
//                           ],
//                           ["Demand ID", `${selectedBillData.DemandGenerationID??"-"}`],
//                             [
//                             "Bill Date",
//                             new Date(
//                               selectedBillData.UploadedOn,
//                             ).toLocaleDateString(),
//                           ],
//                               ["Head Code", `${selectedBillData.BudgetID??"-"}`],
//                           [
//                             "Work Name",
//                             `${selectedBillData.ProjectID??"-"}`,
//                           ],
//                           [
//                             "Work Approved Year",
//                             `${selectedBillData.ProposalYear??"-"}`,
//                           ],
//                             [
//                             "Work order date",
//                              new Date(
//                               selectedBillData.WorkOrderDate,
//                             ).toLocaleDateString(),,
//                           ],
//                             [
//                             "Work Approved Amount",
//                             `${selectedBillData.ApprovedWorkAmount??"-"}`,
//                           ],
//                              [
//                             "Gross Bill Amount",
//                             `${selectedBillData.BillAmount??"-"}`,
//                           ],
//                           [
//                             "R.A.Bill No:",
//                             `${selectedBillData.RABillNumber??"-"}`,
//                           ],
                             
//                           ["Invoice Bill No", `${selectedBillData.InvoiceNo??"-"}`],
                         
//                         ].map(([label, value], index) => (
//                           <tr
//                             key={index}
//                             style={{ border: "1.5px solid #1190CA" }}
//                           >
//                             <td
//                               className="text-start"
//                               style={{
//                                 width: "30%",
//                                 backgroundColor: "#EAF3FB",
//                                 fontWeight: 500,
//                                 padding: "6px 10px",
//                                 borderRight: "1.5px solid #1190CA",
//                               }}
//                             >
//                               {label}
//                             </td>

//                             <td
//                               className="text-start"
//                               style={{
//                                 width: "70%",
//                                 padding: "6px 10px",
//                                 backgroundColor: "#FFFFFF",
//                               }}
//                             >
//                               {value}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                     <table
//                       className="mt-1"
//                       style={{
//                         borderCollapse: "collapse",
//                         border: "1px solid #000",
//                       }}
//                     >
//                       <tbody>
//                         <tr className="border border-dark">
//                           <td
//                             className="text-start border border-dark "
//                             style={{ width: "30%" }}
//                           >
//                             Bill Amount
//                           </td>
//                           <td
//                             className="text-start border border-dark"
//                             style={{ width: "23%" }}
//                           >
//                             Deduction Amount
//                           </td>
//                           {/* <td
//                             className="text-start border border-dark"
//                             style={{ width: "23%" }}
//                           >
//                             Total Bill Amount
//                           </td> */}
//                           <td
//                             className="text-start border border-dark "
//                             style={{ width: "24%" }}
//                           >
//                             Net Payable
//                           </td>
//                         </tr>
//                         <tr>
//                           <td className="text-start border border-dark">
//                             {selectedBillData.BillAmount}
//                           </td>
//                           <td className="text-start border border-dark">
//                             {selectedBillData.DeductionAmount}
//                           </td>
//                           {/* <td className="text-start border border-dark">
//                             {selectedBillData.BillAmount}
//                           </td> */}
//                           <td className="text-start border border-dark">
//                             {selectedBillData.NetPayableAmount}
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     {/* Vendor Details */}
//                     <table
//                       className="mt-2"
//                       style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                         fontSize: "14px",
//                       }}
//                     >
//                       <tbody>
//                         {/* Section Title */}
//                         <tr
//                           style={{
//                             border: "1.5px solid #1190CA",
//                             backgroundColor: "#EAF3FB",
//                           }}
//                         >
//                           <td
//                             colSpan="6"
//                             style={{
//                               padding: "8px 10px",
//                               fontWeight: 600,
//                               textAlign: "center",
//                             }}
//                           >
//                             Vendor Details
//                           </td>
//                         </tr>

//                         {/* Column Headers */}
//                         <tr style={{ border: "1.5px solid #1190CA" }}>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             Vendor Name
//                           </td>
//                           {/* <td style={{ padding: "6px 8px", fontWeight: 500, backgroundColor: "#1190CA", color: "white" }}>PAN Number</td> */}
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             IFSC Code
//                           </td>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             Branch Name
//                           </td>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             Bank Name
//                           </td>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             Account Number
//                           </td>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               fontWeight: 500,
//                               backgroundColor: "#1190CA",
//                               color: "white",
//                             }}
//                           >
//                             Amount{" "}
//                           </td>
//                         </tr>

//                         {fetchSpecificDemandDeductionDetail &&
//                           fetchSpecificDemandDeductionDetail
//                             .filter(
//                               (val) =>
//                                 val.TypeOfAmount == "Total Amount Payable",
//                             )
//                             .map((val, index) => {
//                               return (
//                                 <>
//                                   <tr
//                                     style={{ border: "1.5px solid #1190CA" }}
//                                     key={index}
//                                   >
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.Vendor_Company_Name}
//                                     </td>
//                                     {/* <td style={{ padding: "6px 8px", backgroundColor: "white" }}>{val.Vendor_Company_Name}</td> */}
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.Bank_IFSC_Code}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.Branch_Name}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.BANK_NAME}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.Bank_Account_Number}
//                                     </td>
//                                     <td
//                                       style={{
//                                         padding: "6px 8px",
//                                         backgroundColor: "white",
//                                       }}
//                                     >
//                                       {val.TotalAmount}
//                                     </td>
//                                   </tr>
//                                 </>
//                               );
//                             })}

//                         {/* <tr style={{ border: "1.5px solid #1190CA" }}>
//                           <td
//                           >
//                             Shivsai Construction
//                           </td>
//                           <td className='border border-dark'>AKIPS8199N</td>
//                           <td className='border border-dark'>MAHB0001302</td>
//                           <td className='border border-dark'>BANK OF MAHARASHTRA, GHODBUNDER ROAD</td>
//                           <td className='border border-dark'>2,43,991.0</td>
//                           <td className='border border-dark'> 2,43,991.0</td>
//                         </tr> */}

//                         {/* Total */}
//                         <tr style={{ border: "1.5px solid #1190CA" }}>
//                           <td
//                             style={{
//                               padding: "6px 8px",
//                               backgroundColor: "#EAF3FB",
//                               fontWeight: 500,
//                             }}
//                             colSpan={5}
//                           >
//                             Total
//                           </td>
//                           <td className="border border-dark">
//                             {selectedBillData.NetPayableAmount}
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     <table
//                       className="my-2"
//                       style={{ width: "100%", borderCollapse: "collapse" }}
//                     >
//                       <thead>
//                         <tr
//                           style={{
//                             border: "1.5px solid #1190CA",
//                             backgroundColor: "#EAF3FB",
//                           }}
//                         >
//                           <td
//                             colSpan="6"
//                             style={{
//                               padding: "8px 10px",
//                               fontWeight: 600,
//                               textAlign: "center",
//                             }}
//                           >
//                             Deduction Amount Details
//                           </td>
//                         </tr>
//                         <tr
//                           style={{
//                             color: "white",
//                             border: "none",
//                             height: "3rem",
//                           }}
//                         >
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             Sr No
//                           </th>
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             Deduction Type
//                           </th>
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             Deduction Amount{" "}
//                           </th>
//                           {/* <th style={{ minWidth: "60px", padding: "8px" }}>
//                           Vendor Name
//                         </th> */}
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             Account Number
//                           </th>
//                             <th style={{ minWidth: "60px", padding: "8px" }}>
//                             Bank Name
//                           </th>
//                           <th style={{ minWidth: "60px", padding: "8px" }}>
//                             IFSC
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {fetchSpecificDemandDeductionDetail.filter(
//                           (val) => val.TypeOfAmount != "Total Amount Payable",
//                         )?.length == 0 ? (
//                           <tr>
//                             <td
//                               colSpan="30"
//                               style={{
//                                 textAlign: "center",
//                                 padding: "20px",
//                                 backgroundColor: "#f9f9f9",
//                               }}
//                             >
//                               No data available
//                             </td>
//                           </tr>
//                         ) : (
//                           fetchSpecificDemandDeductionDetail
//                             .filter(
//                               (val) =>
//                                 val.TypeOfAmount != "Total Amount Payable",
//                             )
//                             .map((technicalInwards, index) => {
//                               const bgColor =
//                                 index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                               return (
//                                 <tr
//                                   className="px-3"
//                                   key={index}
//                                   style={{
//                                     borderBottom: "1px solid #3b409e",
//                                     backgroundColor: bgColor,
//                                   }}
//                                 >
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {index + 1}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {technicalInwards.TypeOfAmount}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {technicalInwards.TotalAmount}
//                                   </td>
//                                   {/* <td
//                                   style={{ fontSize: "12px", padding: "5px" }}
//                                 >
//                                   {technicalInwards.Vendor_Company_Name}
//                                 </td> */}
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {technicalInwards.Bank_Account_Number}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {technicalInwards.Bank_Name}
//                                   </td>
//                                   <td
//                                     style={{ fontSize: "12px", padding: "5px" }}
//                                   >
//                                     {technicalInwards.Bank_IFSC_Code}
//                                   </td>
//                                 </tr>
//                               );
//                             })
//                         )}

//                         <tr
//                           style={{
//                             border: "1.5px solid #1190CA",
//                             fontWeight: 600,
//                             background: "white",
//                           }}
//                         >
//                           <td
//                             colSpan="2"
//                             style={{ padding: "6px 8px", textAlign: "right" }}
//                           >
//                             Total
//                           </td>
//                           <td style={{ padding: "6px 8px" }}>
//                             {selectedBillData.DeductionAmount}
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     {/* Signature grid */}
//         <table style={footerTitleStyle}>
//   <tbody>
//     <tr>
//       <td style={footerTitleTdStyle}>
//         मागील देयक तपशील
//       </td>
//     </tr>
//   </tbody>
// </table>

// <table style={remarksTableStyle}>
//   <tbody>
//     <tr>
//       <td style={remarksTableTdStyle}>
//         प्रमाणित करण्यात येते की मा देयकाद्वारे आहारीत करण्यात येत असलेली संपूर्ण रक्कम याच जिल्हात खर्च करण्यात येणार आहे.
//       </td>
//     </tr>
//   </tbody>
// </table>

// <table style={remarksTableStyle}>
//   <tbody>
//     <tr>
//       <td style={remarksTableTdStyle}>
//         स्वाक्षरी आहरण व संवितरण अधिकारी
//       </td>
//     </tr>
//   </tbody>
// </table>

// <table style={instructionTableStyle}>
//   <tbody>
//     <tr>
//       <td style={instructionTableTdStyle}>
//         दुबार देयक प्रतिबंध नोंदवही तपासणीच्या आधारे प्रमाणित करण्यात येते की या देयकात नमूद केलेल्या अधिकाऱ्याचे कर्मचाऱ्याचे / पुरवठादाराचे तसेच त्यात नमूद केलेल्या बाबीचे / कालावधीचे देयक यापूर्वी ग्रामविकास विभाग मुबई येथे सादर करण्यात आले नव्हते. प्रमाणित करण्यात येते की वरील मागणी ही महाराष्ट्र कोषागार नियम / मुंबई वित्तीय नियम / महाराष्ट्र आकस्मिक खर्च नियम व वेळोवेळी विहित केलेल्या आदेशांच्या आधारे तयार करण्यात आली आहे. श्री. किंवा श्रीमती ______________________________ यांना सदर देयकाची रक्कम/किंवा अपेक्षित देयक प्रदान करीता प्राधिकृत करण्यात आले असून त्यांची स्वाक्षरी खालीलप्रमाणे आहे.
//       </td>
//     </tr>
//   </tbody>
// </table>

// {/* <table style={signatureTableStyle}>
//   <tbody>
//     <tr>
//       <td style={signatureTableTdStyle}>
//         <div style={signBoxStyle}>
//           <div style={signSpaceStyle}></div>
//           <div style={signTitleStyle}>
//             संदेश वाहकाची स्वाक्षरी
//           </div>
//         </div>
//       </td>

//       <td style={signatureTableTdStyle}></td>

//       <td style={signatureTableTdStyle}>
//         <div style={signBoxStyle}>
//           <div style={signSpaceStyle}></div>

//           <div style={signTitleStyle}>
//             सही
//           </div>

//           <div style={officerStyle}>
//             DY Secretary / Controller Officer
//           </div>

//           <div style={officerMarathiStyle}>
//             आहरण व संवितरण अधिकारी
//           </div>
//         </div>
//       </td>
//     </tr>
//   </tbody>
// </table> */}


//                     {/* Footer */}
                   
//                   </div>
//               </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//         {loading && (
//           <div
//             style={{
//               position: "fixed",
//               top: 0,
//               left: 0,
//               width: "100%",
//               height: "100%",
//               background: "rgba(255,255,255,0.4)",
//               backdropFilter: "blur(2px)",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               zIndex: 9999,
//             }}
//           >
//             <div className="Adminloader"></div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default ViewDemandGeneration;
